import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  NgModel,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Location } from '@angular/common';
import { EstampService } from '../../services/estamp.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';

import { Subject, debounceTime, Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { catchError, tap } from 'rxjs/operators';
import { UserManagementService } from 'src/app/services/user-management.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { set, uniqueId } from 'lodash';
import { PdfResizeService } from 'src/app/services/pdf-resize.service';
import { PdfSecurityService } from 'src/app/services/pdfsecurity.service';
import { PdfValidationService } from 'src/app/services/pdf-validation.service';

// Custom validator to check for spaces
export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && typeof control.value === 'string') {
      if (control.value.trim().length === 0) {
        return { noSpaces: true };
      }
    }
    return null;
  };
}

export function noScriptTagValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && typeof control.value === 'string') {
      const scriptPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
      if (scriptPattern.test(control.value)) {
        return { scriptDetected: true };
      }
    }
    return null;
  };
}

@Component({
  selector: 'app-estamp-details',
  templateUrl: './estamp-details.component.html',
  styleUrls: ['./estamp-details.component.scss'],
  standalone: false,
})
export class EstampDetailsComponent implements OnInit, AfterViewInit {
  @Input() estampData: any = [];
  @Input() orderStatus: string = '';
  @Output() estampChange: EventEmitter<any> = new EventEmitter<[]>();
  isDraft: boolean = false;

  isDraftLoading: boolean = false;
  currentOrderId: number | null = null;
  states: any;
  articles: any[][] = [];
  selectedState: any;
  estampDetails: FormGroup;
  documentDetailsForm!: FormArray;
  estampLength: any;
  readOnlyName: any = [];
  submitted: boolean = false;
  showPartyDetails: boolean = true;
  public phonePattern: string = '[0-9]{10}';
  showDragDrop!: boolean;
  showWitnessDetails: boolean = false;
  showTemplatePage: boolean = false;
  showPaymentDetails: boolean = false;
  currentPath: any;
  pathId: boolean = false;
  today = new Date();
  minDate = new Date();
  estampDetailsData: any = [];
  stateData: any = [];
  branchData: any = [];
  stampDutyPaidByOptions = [
    { name: 'First Party', code: 'first_party_name' },
    { name: 'Second Party', code: 'second_party_name' },
  ];
  processOptions: any;
  process_type: any;

  selExecutionDate = new Date();
  showPanCard: boolean[] = [false];
  isEstamped: boolean = true;
  estampedYes: boolean = true;
  estampedNo: boolean = false;

  showFileModal: boolean = false;
  selectedFile: File | null = null;
  currentDocumentIndex: number = -1;

  isDragOver: boolean = false;
  fileSizeError: boolean = false;

  showGoogleDriveModal: boolean = false;
  selectedFileBase64: string = '';

  showLinkModal: boolean = false;
  showDropboxModal = false;
  showOneDriveModal = false;
  previewModalVisible: boolean = false;
  previewFile: File | null = null;
  previewPdfSrc: any = null;
  previewFileName: string = '';
  activePreviewEstampIndex: number = -1;
  previewModalMode: 'upload' | 'preview' = 'preview';
  newlyUploadedEstampIndex: number = -1;
  stagedUploadFile: File | null = null;
  uploadedFileObjects: { [index: number]: File } = {};
  private draftLoaded: Boolean = false;

  @ViewChild('bulkOptionModal') bulkOptionModal!: ElementRef;
  @ViewChild('bulkOptionModalPopup') bulkOptionModalPopup!: ElementRef;
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;

  @ViewChild('validateModalPopup') validateModalPopup!: ElementRef;
  @ViewChild('closeValidatePopupBtn') closeValidatePopupBtn!: ElementRef;

  @ViewChild('closeDataConfirmPopupBtn') closeDataConfirmPopupBtn!: ElementRef;
  @ViewChild('validateDataModalPopup') validateDataModalPopup!: ElementRef;

  backValue: string;
  selectedBranch: any;
  stateSelected: any;
  enableRefIdField: boolean;
  isDatavalidated: boolean = false;
  estampDataForValidation: AbstractControl<any, any>[];
  account_id: string;
  estamp_default_fields: any;

  default: boolean;
  custom: boolean;
  isDefault: boolean = false;
  private defaultLimitMessageShown: boolean = false;
  denominationData: any[] = [];
  stampDutyAmount: number;
  selectedArticleAmount: any = [];
  readOnlyStampAmt: boolean = false;
  onConsidrPriceChange: Subject<{ articleId: any; event: any; index: any }> =
    new Subject<{ articleId: any; event: any; index: any }>();
  isConsiderationPriceValid: boolean[] = [true];
  isStampValueValid: boolean[] = [true];
  considerationPriceInWords: number[] = [0];
  stampAmountInWords: number[] = [];
  showEstampSettings: boolean = false;
  minStampValue: (number | null)[] = [];
  paymentbySignerYes: boolean = true;
  paymentbySignerNo: boolean = false;
  articleData: { state_code: any };
  showPayment: any;
  readOnlyFields: boolean = false;
  private stateWasManuallyChanged = false; 
  private panValuesByMode: Record<
    'default' | 'custom',
    { first_party_pan: string; second_party_pan: string }
  > = {
    default: { first_party_pan: '', second_party_pan: '' },
    custom: { first_party_pan: '', second_party_pan: '' },
  };
  showHdfcFields: boolean = true;
  organisationId: any;
  fileSelectedMap: { [index: number]: boolean } = {};
  placeData: any = [
    { code: 'Bangalore', name: 'Bangalore' },
    { code: 'Rajajinagar', name: 'Rajajinagar' },
    { code: 'Kanakpura Road', name: 'Kanakpura Road' },
    { code: 'Rajmahal Vilas Extension', name: 'Rajmahal Vilas Extension' },
    { code: 'Sahakaranagar', name: 'Sahakaranagar' },
    { code: 'Yelahanka', name: 'Yelahanka' },
    { code: 'Kengeri', name: 'Kengeri' },
    { code: 'Jakkur Road', name: 'Jakkur Road' },
    { code: 'Banashankari', name: 'Banashankari' },
    {
      code: 'Kasturba Road 2nd Floor(BKBR)',
      name: 'Kasturba Road 2nd Floor(BKBR)',
    },
    { code: 'Kalyan Nagar', name: 'Kalyan Nagar' },
    { code: 'Electronic City', name: 'Electronic City' },
    { code: 'Jayanagar', name: 'Jayanagar' },
    { code: 'Koramangala', name: 'Koramangala' },
    { code: 'Mahadevpura', name: 'Mahadevpura' },
    { code: 'Marathahalli', name: 'Marathahalli' },
    { code: 'Sarjapur Road', name: 'Sarjapur Road' },
    { code: 'Whitefield', name: 'Whitefield' },
    { code: 'HSR layout', name: 'HSR layout' },
    { code: 'Tumkur', name: 'Tumkur' },
    { code: 'Davanagere', name: 'Davanagere' },
    { code: 'Hosur', name: 'Hosur' },
  ];
  defaultState: any = [];
  defaultBranch: any = [];
  stateDefault: any;
  state_id: any;
  readOnlyDefault: boolean[] = [false];
  userId: string;
  userData: any;
  userBranches: any;
  branchDefault: any;
  estamp_field_editable: any;
  sync_second_party_and_price: boolean = false;
  setEstampDefaultDetails: any = [];
  formData: any = [];
  formEstampData: any = [];
  additionalForm: FormArray;
  eStampAdditionalForm: FormArray;
  contractType: boolean = false;
  showFields: boolean = false;
  showIndividualFields: boolean = false;
  othersSelectedMap: { [key: string]: boolean } = {}; // Tracks if "OTHERS" is selected for dropdown fields
  savedData: any = {};
  service: string = '';
  is_wallet: boolean = false;
  isCatFlow: boolean = false;
  paymentbyWallet: string = 'wallet';
  paymentbyRazorpay: string = 'razorpay';
  payLater: string = 'payLater';
  isPreProcurement: boolean = false;
  isDocumentType: string = '003';
  inventoryPayment: boolean = false;
  validationForRazorypay: boolean = false;

  defaultDescriptions: { [key: number]: string } = {};
  private isProcessingDropboxFile: boolean = false;
  private readonly MIN_PDF_SIZE_BYTES = 100; // If file size is less than 100 bytes (â‰ˆ0.1 KB), treat it as invalid

  get dropboxEnabled(): boolean {
    return this.storageService?.getDropBoxEnabled() || false;
  }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private messageService: MessageService,
    private _location: Location,
    private userDashboardService: UserDashboardService,
    private estampService: EstampService,
    private modalService: NgbModal,
    private userManagementService: UserManagementService,
    private catUploadService: CatUploadService,
    private cdr: ChangeDetectorRef,
    private pdfResizeService: PdfResizeService,
    private route: ActivatedRoute,
    private pdfSecurityService: PdfSecurityService,
    private pdfValidationService: PdfValidationService,
  ) {
    this.additionalForm = this.formBuilder.array([]);
    this.selectedBranch = this.storageService.getBranch() || null;
    this.eStampAdditionalForm = this.formBuilder.array([]);

    this.organisationId = this.storageService.getOrganization() || '';
    this.showHdfcFields = this.organisationId === 'HDHO';
    this.showPayment = this.storageService.getOrderPayment() || null;
    this.storageService.getBranchChangeObservable().subscribe((branch) => {
      this.selectedBranch = branch;
    });

    if (this._location.path() == '/doqfy/e-stamp/form') {
      this.pathId = true;
    } else {
      this.pathId = false;
    }

    if (this._location.path() == '/doqfy/cat-execution/form') {
      this.backValue = 'uploadDocs';
      this.isCatFlow = true;
    } else if (this._location.path() == '/doqfy/cat-edit/form') {
      this.backValue = 'editTemplate';
      this.isCatFlow = true;
    }
    const panPattern = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$';
    this.estampDetails = this.formBuilder.group({
      toBeEStamped: [true, [Validators.required]],
      documentDetailsForm: this.formBuilder.array([]),
      referenceNumber: new FormControl('', [
        Validators.maxLength(80),
        noScriptTagValidator(),
      ]),
      toBeDefault: [this.isDefault],
      paymentbySigner: [false, [Validators.required]],
      paymentMethod: ['payLater', [Validators.required]],
      amountToPay: [''],
      payeeName: [''],
      payeeEmail: [
        '',
        [
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      payeeMobileNumber: [
        '',
        [
          Validators.pattern(this.phonePattern),
          Validators.maxLength(10),
          Validators.minLength(10),
        ],
      ],
      state_code: [''],
      first_party_pan: ['', [Validators.pattern(panPattern)]],
      second_party_pan: ['', [Validators.pattern(panPattern)]],
    });

    this.account_id = this.storageService.getAccountId() || null;
    this.stateDefault = this.storageService.getState() || null;
    this.estamp_field_editable = this.storageService.getStampEdit() || null;
    this.sync_second_party_and_price = this.storageService.getSyncSecondPartyAndPrice() || false;
    if (this.stateDefault) {
      this.state_id = this.stateDefault.id;
      this.stateSelected = this.stateDefault;
    }

    this.onConsidrPriceChange
      .pipe(debounceTime(1500))
      .subscribe(({ articleId, event, index }) => {
         if (event === null || event === undefined || event === 0) {
          return;
        }
        this.getStateDenomination(
          this.stateSelected.state_code,
          articleId,
          event,
          index,
          this.account_id,
        );
      });

    // this.getRefIdConsent();

    // Check multiple estamp for document
    this.route.queryParams.subscribe((params) => {
      const nextService =
        params['service']?.toUpperCase() === 'MULTIPLE-STAMP'
          ? 'MULTIPLE-STAMP'
          : 'ESTAMP';
      if (this.service && this.service !== nextService) {
        this.documentDetailsArray().clear();
        this.eStampAdditionalForm.clear();
        this.estampData = undefined;
        this.estampDetailsData = [];
        this.savedData = null;
        this.fileSelectedMap = {};
        this.readOnlyName = [];
        this.isConsiderationPriceValid = [];
        this.isStampValueValid = [];
        this.considerationPriceInWords = [];
        this.stampAmountInWords = [];
        this.denominationData = [];
      }
      this.service = nextService;
      if (
        this.service === 'MULTIPLE-STAMP' &&
        this.isEstamped &&
        this.documentDetailsArray().length === 0
      ) {
        this.addNewDetails();
      }
    });
    this.is_wallet = this.storageService.getIsWallet();
    this.process_type = 'PRE_PROCUREMENT';
    this.storageService.isDocumentType$.subscribe((type) => {
      const previousType = this.isDocumentType;
      this.isDocumentType = type;
      if (
        previousType !== type &&
        (
          ['001', '002'].includes(String(type)) ||
          ['001', '002'].includes(String(previousType))
        )
      ) {
        setTimeout(() => this.getStateDetails());
      }
    });
    if (this.isDocumentType !== '003') {
      this.process_type = 'ON_THE_FLY';
      this.isPreProcurement = false;
    }
    this.storageService.inventoryPayment$.subscribe((inventoryPayment) => {
      if (inventoryPayment) {
        this.isPreProcurement = false;
        this.showPaymentDetails = true;
        this.validationForRazorypay = true;
      } else {
        this.isPreProcurement = true;
        this.showPaymentDetails = false;
        this.validationForRazorypay = false;
      }
      this.inventoryPayment = inventoryPayment;
    });
  }

  onReferencePaste(event: ClipboardEvent): void {
    if (!this.enableRefIdField) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const sanitized = clipboardData.replace(/[^a-zA-Z0-9_-]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const currentValue = input.value;
    const newValue =
      currentValue.slice(0, start) + sanitized + currentValue.slice(end);
    this.estampDetails.get('referenceNumber')?.setValue(newValue);
  }

  ngOnInit(): void {
    this.savedData = this.catUploadService.getEstampFormData();
    this.isEstamped = true;
    this.getStateDetails();
    this.currentPath = this._location.path();
    this.getEstampDefaultDetails();
    this.tobeEstamped(true);
    this.userId = this.storageService.getUserID() || null;
    if (this.userId) {
      this.getUserDetails(this.userId);
    }

    this.getEstampAddionalFields();
    this.denominationData = [];
    this.articles = [];
    let providerCode: string = 'RAZORPAY_GATEWAY';
    let providers = this.getAvailableProviders();
    let paymentOption: any;

    if (this.is_wallet) {
      paymentOption = this.paymentbyWallet;
      providerCode = 'WALLET';
    } else if (providers.includes('RAZORPAY_GATEWAY')) {
      paymentOption = this.paymentbyRazorpay;
      providerCode = 'RAZORPAY_GATEWAY';
    } else if (providers.includes('HDFC_GATEWAY')) {
      paymentOption = 'HDFC_GATEWAY';
      providerCode = 'HDFC_GATEWAY';
    } else {
      paymentOption = this.payLater;
    }
    this.estampDetails.controls.paymentMethod.setValue(paymentOption);
    this.storageService.setSelectedProvider(providerCode);

    // Handle UI state based on the initial selection
    if (
      paymentOption === this.paymentbyRazorpay ||
      paymentOption === 'HDFC_GATEWAY'
    ) {
      this.showPaymentDetails = true;
      this.validationForRazorypay = true;
    }

    if (
      paymentOption === this.payLater ||
      (this.isPreProcurement === true &&
        !this.inventoryPayment &&
        paymentOption !== this.paymentbyWallet)
    ) {
      this.estampDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    } else {
      this.estampDetails.controls.paymentbySigner.setValue(true);
      this.storageService.getSignerValue.next(true);
    }
    // --- NEW DRAFT LOGIC START ---
    this.route.queryParams.subscribe((params) => {
      this.currentOrderId = params['order_id'] ? +params['order_id'] : null;
      // Fetch draft from storage
      setTimeout(() => {
        const draftData = this.storageService.getDraftData();
        // Verify draft matches current order ID
        if (
          this.currentOrderId !== null &&
          draftData &&
          draftData.order.id === this.currentOrderId
        ) {
          //Handle Reference Number (Prioritize Draft ID)
          this.draftLoaded = true;
          this.getRefIdConsent(draftData);
          this.populateFormWithDraft(draftData);
        } else {
          this.getRefIdConsent();
        }
      }, 200);
    });

    this.storageService.isDraftOrder$.subscribe((val) => {
      this.isDraft = val;
    });

    this.updateRazorypayFieldValidation();
  }

  ngOnDestroy() {
    this.storageService.setDraftMode(false);
  }

  getEstampDefaultDetails() {
    this.showEstampSettings = this.storageService.getEstampDefault() || null;
    if (this.showHdfcFields) {
      this.readOnlyFields = this.showEstampSettings;
    }
  }

  getUserDetails(id) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      this.userData = res['content'][0];
      this.userBranches = this.userData.branches;
    });
  }

  preventNumberInputScroll(event: Event) {
    event.preventDefault();
  }

  //----------------------------------------------Get Addinional Fields details ------------------------------------//

  getEstampAddionalFields() {
    this.contractType = this.storageService.getContractType();
    const contractId = this.storageService.getContractNumber();
    if (this.contractType) {
      this.showFields = false;
      this.catUploadService
        .getAddionalFieldDetails(contractId)
        .subscribe((res) => {
          this.formData = res['content'];
          const filteredData = this.formData.filter((item: any) => {
            const key = Object.keys(item)[0];
            const module = item[key].module;
            return module === 'estamp' || module === 'estamp.stamp';
          });
          this.formData = filteredData;
          this.createAdditionalForm();
        });
    }
  }

  createAdditionalForm() {
    const index = this.documentDetailsArray().length - 1;
    const formGroup = this.formBuilder.group({});
    this.formData.forEach((item: any) => {
      const key = Object.keys(item)[0]; // Field key
      const field = item[key]; // Field details
      const value = this.savedData?.[index]?.[key] || '';
      if (field.module === 'estamp') {
        const control = field.mandatory
          ? new FormControl(value, Validators.required)
          : new FormControl(value);
        formGroup.addControl(key, control);
      }
      this.additionalForm.push(formGroup);
    });
  }

  getEstampIndividualFields(stateCode: string, index?: number) {
    if (!['WB', 'MP'].includes(stateCode)) {
      return 0;
    }
    const filteredData = this.formData.filter((item: any) => {
      const key = Object.keys(item)[0];
      const stateCodes = item[key]?.state_code;
      const isStateCodeValid =
        !stateCodes ||
        stateCodes.some((state: any) => Object.keys(state)[0] === stateCode);
      return isStateCodeValid;
    });

    this.formEstampData = filteredData;
    this.createEstampAdditionalForm(index);
  }

  createEstampAdditionalForm(index?: number) {
    this.showIndividualFields = false;
    const formGroup = this.formBuilder.group({});
    this.formEstampData.forEach((item: any) => {
      const key = Object.keys(item)[0];
      const field = item[key];
      const fieldValue = this.savedData?.[index]?.[key] || '';

      if (field.module === 'estamp.stamp') {
        this.showIndividualFields = true;

        const control = field.mandatory
          ? new FormControl(fieldValue, Validators.required)
          : new FormControl(fieldValue);
        formGroup.addControl(key, control);

        if (field.data_type === 'dropdown') {
          this.othersSelectedMap[key] = false;
          formGroup.get(key)?.valueChanges.subscribe((value) => {
            if (value === 'OT') {
              const otherKey = key.replace('Type', 'Name');
              const otherValue = {
                [otherKey]: {
                  label: otherKey,
                  mandatory: true,
                  data_type: 'text',
                  module: 'estamp.stamp',
                },
              };
              const index = this.formEstampData.findIndex(
                (item) => Object.keys(item)[0] === otherKey,
              );

              if (index === -1) {
                this.formEstampData.push(otherValue);
              } else {
                this.formEstampData[index] = otherValue;
              }

              this.othersSelectedMap[key] = true;
              formGroup.addControl(
                otherKey,
                new FormControl(
                  this.savedData?.[index]?.[otherKey] || '',
                  Validators.required,
                ),
              );
            } else {
              const otherKey = key.replace('Type', 'Name');
              this.formEstampData = this.formEstampData.filter(
                (item) => Object.keys(item)[0] !== otherKey,
              );

              this.othersSelectedMap[key] = false;
              formGroup.removeControl(otherKey);
            }
          });
          formGroup.get(key)?.setValue(fieldValue);
        }
      }
    });
    (this.eStampAdditionalForm as FormArray).setControl(index, formGroup);
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getOptionKey(option: Record<string, string>): string {
    return Object.keys(option)[0];
  }

  getOptionValue(option: Record<string, string>): string {
    return Object.values(option)[0];
  }

  //--------------------------------------------------------------------------------------------------------------------//

  //-------------------------------------------- GetDefaultFieldData--------------------------------------------------------//

  getDefaultFieldData(account_id) {
    this.showEstampSettings = this.storageService.getEstampDefault() || null;

    if (this.showEstampSettings) {
      this.userDashboardService
        .getDefaultFieldData(account_id)
        .subscribe((res: any) => {
          if (res && res['content'] && res['content']['estamp_data']) {
            this.estamp_default_fields = res['content']['estamp_data'];

            this.setEstampDefaultDetails = [];

            this.estamp_default_fields.forEach((eStamp: any) => {
              const estampFields = eStamp.estamp_default_fields;

              if (estampFields.account_info.id === account_id) {
                const currentBranchId =
                  this.selectedBranch?.id || this.selectedBranch;

                estampFields.state_wise_stamp_duty.forEach((element: any) => {
                  const elementHasBranch =
                    element.branch_id !== null &&
                    element.branch_id !== undefined &&
                    element.branch_id !== '';

                  const stateMatches = element.state_id === this.state_id;

                  // If element has a branch_id, match both branch AND state.
                  // If element has no branch_id, match on state only â€” branch is optional.
                  const branchMatches = elementHasBranch
                    ? element.branch_id === currentBranchId && stateMatches
                    : stateMatches;

                  if (branchMatches) {
                    const stampDutyAmount = Array.isArray(
                      element.stamp_duty_amounts[0],
                    )
                      ? element.stamp_duty_amounts[0][0]
                      : element.stamp_duty_amounts[0];

                    const defaultData = {
                      articleNumber: element.article_id,
                      stampDutyValue: stampDutyAmount,
                      considerationPrice: element.consideration_amount,
                      accountId: estampFields.account_info.id,
                      stateId: element.state_id,
                      branchId: element.branch_id,
                      estampData: estampFields,
                      description: element.description,
                      articleCode: element.article_code,
                      process_type:
                        this.isDocumentType !== '003'
                          ? 'ON_THE_FLY'
                          : element.process_type ||
                            estampFields.process_type ||
                            'PRE_PROCUREMENT',
                    };
                    this.setEstampDefaultDetails.push(defaultData);
                  }
                });
              }
            });

            if (this.setEstampDefaultDetails.length > 0) {
              let firstMatch = this.setEstampDefaultDetails[0];
              let isDefaultOnTheFly = firstMatch.process_type === 'ON_THE_FLY';
              this.readOnlyFields = false;
              this.readOnlyDefault = this.readOnlyDefault.map(() => !this.estamp_field_editable);
              this.process_type = firstMatch.process_type;
              this.documentDetailsArray().controls.forEach(
                (group: FormGroup) => {
                  group.patchValue({ process_type: firstMatch.process_type });
                },
              );

              if (isDefaultOnTheFly && this.showPayment) {
                const currentPaymentMethod =
                  this.estampDetails.controls.paymentMethod.value;
                const isGateway =
                  currentPaymentMethod === this.paymentbyRazorpay ||
                  currentPaymentMethod === 'HDFC_GATEWAY';
                this.isPreProcurement = false;
                if (isGateway) {
                  this.showPaymentDetails = true;
                  this.validationForRazorypay = true;
                  this.updateRazorypayFieldValidation();
                }
              }
              this.onProcessChange({ value: firstMatch.process_type });
            }

            this.populateDefaultsForCurrentState();
          }
        });
    }
  }

  populateDefaultsForCurrentState() {
    if (this.custom) {
      return;
    }

    const currentStateDefaults = this.setEstampDefaultDetails.filter(
      (item) => item.stateId === this.state_id,
    );

    if (this.draftLoaded) {
      console.log('Draft already loaded - skipping defaults');
      this.setDefaultArticles();
      return;
    }

    const draftData = this.storageService.getDraftData();
    const hasValidDraft =
      draftData &&
      draftData.order?.id === this.currentOrderId &&
      draftData.estamp &&
      draftData.estamp.length > 0;

    if (hasValidDraft) {
      console.log('Draft has priority - skipping defaults');
      this.setDefaultArticles();
      return;
    }

    if (currentStateDefaults.length > 0) {
      const currentStateDefault = currentStateDefaults[0];
      const estampData = currentStateDefault.estampData;
      const filteredData = this.filterStampDataForCurrentState(estampData);

      if (filteredData.state_wise_stamp_duty.length > 0) {
        this.populateStateWiseStampDuty({
          estamp_default_fields: filteredData,
        });
        this.updateFormArray({ estamp_default_fields: filteredData });

        const documentDetails = this.documentDetailsArray();

        documentDetails.controls.forEach((control, index) => {
          if (
            this.service === 'MULTIPLE-STAMP' &&
            control.get('documentToBeEstamp')?.value === false
          ) {
            return;
          }
          if (!control.get('firstPartyName')?.value) {
            control
              .get('firstPartyName')
              ?.setValue(estampData.first_party_name, { emitEvent: false });
          }
          if (!control.get('secondPartyName')?.value) {
            control
              .get('secondPartyName')
              ?.setValue(estampData.second_party_name, { emitEvent: false });
          }
          if (!control.get('purposeOfStampDuty')?.value) {
            control
              .get('purposeOfStampDuty')
              ?.setValue(
                filteredData.state_wise_stamp_duty[0]?.description || '',
                { emitEvent: false },
              );
          }
          if (!control.get('articleNumber')?.value) {
            control.get('articleNumber')?.setValue(null);
          }
        });

        // Delay article selection
        setTimeout(() => {
          if (this.custom) {
            return;
          }

          let stampDataIdx = 0;
          documentDetails.controls.forEach((row, index) => {
            if (
              this.service === 'MULTIPLE-STAMP' &&
              row.get('documentToBeEstamp')?.value === false
            ) {
              return;
            }

            const stateData = filteredData.state_wise_stamp_duty[stampDataIdx];
            if (!stateData) return;
            stampDataIdx++;

            if (!row.get('articleNumber')?.value) {
              row.get('articleNumber')?.setValue(stateData.article_id);
              this.onArticleNumberChange(
                { value: stateData.article_id },
                index,
              );
            }

            // Re-apply default stamp and consideration values AFTER onArticleNumberChange clears them
            const stampDutyValue = Array.isArray(stateData.stamp_duty_amounts)
              ? stateData.stamp_duty_amounts[0]
              : stateData.stamp_duty_amounts;

            setTimeout(() => {
              if (this.custom) {
                return;
              }

              row.patchValue({
                stampDutyValue: stampDutyValue,
                considerationPrice: stateData.consideration_amount,
              });
              this.stampAmountInWords[index] = stampDutyValue;
              this.considerationPriceInWords[index] =
                stateData.consideration_amount;
              this.denominationData[index] = [{ amount: stampDutyValue }];
              this.estampDetails.updateValueAndValidity();
              this.cdr.detectChanges();
            }, 600);
          });

          this.setDefaultArticles();
        }, 1500);
      } else {
        this.loadEmptyFormForState();
        this.setDefaultArticles();
      }
    } else {
      this.loadEmptyFormForState();
      this.setDefaultArticles();
    }
  }

  filterStampDataForCurrentState(estampData) {
    const filteredStampDuty = this.setEstampDefaultDetails.filter(
      (item) => item.stateId === this.state_id,
    );

    const stateWiseStampDuty = filteredStampDuty.map((item) => ({
      id: 0, // You might need to adjust this
      account_id: item.accountId,
      account_name: estampData.account_info.account_name,
      branch_id: 0, // You might need to get this from somewhere
      branch_name: '',
      article_id: item.articleNumber,
      article_code: '', // You might need to get this from articles data
      state_id: item.stateId,
      state_name: '', // You might need to get this from state data
      stamp_duty_amounts: [item.stampDutyValue],
      consideration_amount: item.considerationPrice,
      description:
        estampData.state_wise_stamp_duty.find(
          (s) => s.article_id === item.articleNumber,
        )?.description || '',
    }));

    return {
      ...estampData,
      state_wise_stamp_duty: stateWiseStampDuty,
    };
  }

  loadEmptyFormForState() {
    this.readOnlyDefault[0] = false;
    this.getBranchDefault(this.stateSelected.id);
    this.getEstampIndividualFields(
      this.stateSelected.state_code,
      this.estampLength - 1,
    );
    this.getArticles(this.stateSelected.state_code).subscribe((response) => {});
  }

  onStateChange(newStateId) {
    this.state_id = newStateId;
    if (
      this.setEstampDefaultDetails &&
      this.setEstampDefaultDetails.length > 0
    ) {
      this.populateDefaultsForCurrentState();
    }
  }

  filterStampData(data) {
    const filteredStampDuty =
      data.estamp_default_fields.state_wise_stamp_duty.filter(
        (item) => item.state_id === this.state_id,
      );
    return {
      ...data,
      estamp_default_fields: {
        ...data.estamp_default_fields,
        state_wise_stamp_duty: filteredStampDuty,
      },
    };
  }

  populateStateWiseStampDuty(eStamp) {
    if (eStamp.estamp_default_fields.state_wise_stamp_duty.length != 0) {
      eStamp.estamp_default_fields.state_wise_stamp_duty.forEach(
        (element, index) => {
          this.updateDefaultState(element, index);
          this.readOnlyDefault[index] = !this.estamp_field_editable;
        },
      );
    } else {
      this.readOnlyDefault[0] = false;
      this.getBranchDefault(this.stateSelected.id);
      this.getEstampIndividualFields(
        this.stateSelected.state_code,
        this.estampLength - 1,
      );
      this.getArticles(this.stateSelected.state_code).subscribe(
        (response) => {},
      );
    }
  }

  updateDefaultState(element, index) {
    this.stateData.forEach((state) => {
      if (state.id === element.state_id) {
        this.stateSelected = state;
        this.defaultState[index] = state;
        this.getArticles(state.state_code).subscribe((response) => {
          const filteredArray2 = this.articles[0].filter((item2) =>
            this.setEstampDefaultDetails.some(
              (item1) => item1.articleNumber === item2.id,
            ),
          );

          if (filteredArray2.length != 0) {
            this.articles[0] = filteredArray2;
          }
        });
      }
    });
  }

  setDefaultBranch(selectedBranch, patchForm: boolean = true) {
    this.selectedBranch = selectedBranch.value;
    this.storageService.setBranch(this.selectedBranch);
    this.storageService.setBranchId(this.selectedBranch.id);
    if (!patchForm) {
      return;
    }
    this.documentDetailsArray().controls.forEach((group: FormGroup) => {
      group.patchValue({
        selectBranch: this.selectedBranch,
      });
    });
    if (patchForm && this.isDefault) {
      this.getDefaultFieldData(this.account_id);
    }
  }

  // Second Party Name is one of the fields driven by the first stamp detail when
  // sync_second_party_and_price is enabled: row 0 is editable and every change there
  // propagates to the other rows, which stay locked because they only mirror row 0.
  // When sync is OFF the field is freely editable on every row.
  isSecondPartyNameLocked(index: number): boolean {
    // In Custom mode, or when "Edit EStamp Default Details" is enabled, everything
    // is editable.
    if (this.custom || this.estamp_field_editable) {
      return false;
    }
    // When sync is OFF, Second Party Name is always editable.
    if (!this.sync_second_party_and_price) {
      return false;
    }
    // Sync ON: the first stamp detail drives the value and is editable; every other
    // row mirrors it and is therefore always locked, whether or not that row has a
    // configured default.
    return index !== 0;
  }

  // These fields (Select State, Select Branch, Process By, First Party Name,
  // Stamp Duty Paid By, Purpose Of Stamp Duty, Article Number) are non-editable
  // when sync is OFF and the E-Stamp settings are locked (Default mode with
  // "Edit EStamp Default Details" disabled). In Custom mode everything is editable,
  // because readOnlyFields / readOnlyDefault are all cleared there.
  isSyncOffLocked(index: number): boolean {
    // In Custom mode, or when "Edit EStamp Default Details" is enabled, everything
    // is editable.
    if (this.custom || this.estamp_field_editable) {
      return false;
    }
    // When sync is OFF, these fields are non-editable only when this stamp row is
    // actually backed by locked default data (readOnlyDefault[index] === true).
    // If no default exists for this index (e.g. adding an extra E-stamp beyond the
    // number of configured defaults, or no defaults configured at all), the row
    // must be editable.
    if (!this.sync_second_party_and_price) {
      return !!this.readOnlyDefault[index];
    }
    // When sync is ON, Select State / Select Branch / Process By / First Party Name
    // are non-editable on every stamp detail (they are inherited from the account
    // defaults and synced across rows).
    return true;
  }

  // Purpose Of Stamp Duty, Article Number and Stamp Duty Value:
  // - sync OFF: non-editable (unless Custom / edit toggle enabled).
  // - sync ON: editable on every stamp detail (index 0 and 1+).
  isSyncEditableFieldLocked(index: number): boolean {
    // In Custom mode, or when "Edit EStamp Default Details" is enabled, everything
    // is editable.
    if (this.custom || this.estamp_field_editable) {
      return false;
    }
    if (this.sync_second_party_and_price) {
      return false;
    }
    // Sync OFF: these fields are non-editable only when this stamp row is actually
    // backed by locked default data (readOnlyDefault[index] === true). When no
    // default exists for this index (extra E-stamp beyond configured defaults, or
    // no defaults configured), the row must be editable.
    return !!this.readOnlyDefault[index];
  }

  // When sync_second_party_and_price is enabled, Purpose Of Stamp Duty, Article Number and Stamp Duty
  // Value become independently editable from the second stamp detail onwards, overriding the
  // general "Edit EStamp Default Details" lock for those fields only.
  isSyncSecondPartyAndPriceEditable(index: number): boolean {
    return this.sync_second_party_and_price && index !== 0;
  }

  // When sync_second_party_and_price is enabled, Stamp Duty Paid By, Purpose Of Stamp Duty and
  // Article Number behave like Second Party Name / Consideration Price: the first stamp detail
  // (index 0) is always editable and every change there propagates to the rest, while the other
  // stamp details are locked.
  isSyncFieldLocked(index: number): boolean {
    // In Custom mode, or when "Edit EStamp Default Details" is enabled, everything
    // is editable.
    if (this.custom || this.estamp_field_editable) {
      return false;
    }
    // When sync is OFF, Stamp Duty Paid By is non-editable only when this stamp row
    // is actually backed by locked default data. Rows without a configured default
    // (extra E-stamp beyond configured defaults, or none configured) stay editable.
    if (!this.sync_second_party_and_price) {
      return !!this.readOnlyDefault[index];
    }
    // Sync ON: the first stamp detail drives the value and is editable; every other
    // row mirrors it and is therefore always locked, whether or not that row has a
    // configured default.
    return index !== 0;
  }

  onSecondPartyNameInput(index: number, event: Event): void {
    if (index !== 0 || !this.sync_second_party_and_price) {
      return;
    }
    const value = (event.target as HTMLInputElement).value;
    const formArray = this.documentDetailsArray();
    for (let i = 1; i < formArray.length; i++) {
      formArray.at(i).get('secondPartyName')?.setValue(value, { emitEvent: false });
    }
  }

  // Propagate the first stamp detail's value to all the other stamp details for the given control.
  private syncControlFromFirst(controlName: string, value: any): void {
    if (!this.sync_second_party_and_price) {
      return;
    }
    const formArray = this.documentDetailsArray();
    for (let i = 1; i < formArray.length; i++) {
      formArray.at(i).get(controlName)?.setValue(value, { emitEvent: false });
    }
  }

  onStampDutyPaidBySync(index: number): void {
    if (index !== 0 || !this.sync_second_party_and_price) {
      return;
    }
    const value = this.documentDetailsArray().at(0).get('stampDutyPaidBy')?.value;
    this.syncControlFromFirst('stampDutyPaidBy', value);
  }

  onExecutionDateSync(index: number): void {
    if (index !== 0 || !this.sync_second_party_and_price) {
      return;
    }
    const value = this.documentDetailsArray().at(0).get('execution_date')?.value;
    this.syncControlFromFirst('execution_date', value);
  }

  isConsiderationPriceLocked(index: number): boolean {
    // In Custom mode, or when "Edit EStamp Default Details" is enabled, everything
    // is editable.
    if (this.custom || this.estamp_field_editable) {
      return false;
    }
    if (this.sync_second_party_and_price) {
      // Sync ON: the first stamp detail drives the value and is editable; every other
      // row mirrors it and is therefore always locked, whether or not that row has a
      // configured default.
      return index !== 0;
    }
    // When sync is OFF, Consideration Price is always editable.
    return false;
  }

  isStampDutyValueLocked(index: number): boolean {
    if (this.isOperationalNeslContract) {
      return this.readOnlyStampAmt;
    }
    return false;
  }

  onConsiderationPriceSync(index: number, event: Event): void {
    if (index !== 0 || !this.sync_second_party_and_price) {
      return;
    }
    const value = (event.target as HTMLInputElement).value;
    const formArray = this.documentDetailsArray();
    for (let i = 1; i < formArray.length; i++) {
      formArray.at(i).get('considerationPrice')?.setValue(value, { emitEvent: false });
    }
  }

  private validateSecondPartyNameConsistency(): void {
    if (!this.sync_second_party_and_price) {
      return;
    }
    const formArray = this.documentDetailsArray();
    if (formArray.length <= 1) {
      return;
    }
    const referenceName = formArray.at(0).get('secondPartyName')?.value;
    let hasMismatch = false;

    for (let i = 1; i < formArray.length; i++) {
      const control = formArray.at(i).get('secondPartyName');
      if (control && control.value !== referenceName) {
        hasMismatch = true;
        control.setValue(referenceName, { emitEvent: false });
      }
    }

    if (hasMismatch) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Second Party Name Mismatch',
        detail:
          'Second Party Name must be the same across all stamp details. Values have been synced to the first stamp detail and are now locked.',
        life: 5000,
      });
    }
  }

  private validateConsiderationPriceConsistency(): void {
    if (!this.sync_second_party_and_price) {
      return;
    }
    const formArray = this.documentDetailsArray();
    if (formArray.length <= 1) {
      return;
    }
    const referenceValue = formArray.at(0).get('considerationPrice')?.value;
    let hasMismatch = false;

    for (let i = 1; i < formArray.length; i++) {
      const control = formArray.at(i).get('considerationPrice');
      if (control && control.value !== referenceValue) {
        hasMismatch = true;
        control.setValue(referenceValue, { emitEvent: false });
      }
    }

    if (hasMismatch) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Consideration Price Mismatch',
        detail:
          'Consideration Price must be the same across all stamp details. Values have been synced to the first stamp detail and are now locked.',
        life: 5000,
      });
    }
  }

  // Sync Stamp Duty Paid By and Execution Date to the first stamp detail's value
  // whenever sync_second_party_and_price is enabled (e.g. after a draft is loaded).
  private validateSyncFieldsConsistency(): void {
    if (!this.sync_second_party_and_price) {
      return;
    }
    const formArray = this.documentDetailsArray();
    if (formArray.length <= 1) {
      return;
    }

    ['stampDutyPaidBy', 'execution_date'].forEach((controlName) => {
      const referenceValue = formArray.at(0).get(controlName)?.value;
      for (let i = 1; i < formArray.length; i++) {
        const control = formArray.at(i).get(controlName);
        if (control && control.value !== referenceValue) {
          control.setValue(referenceValue, { emitEvent: false });
        }
      }
    });
  }

  private lastReadonlyToastAt = 0;

  showReadonlyMessage() {
    const now = Date.now();
    if (now - this.lastReadonlyToastAt < 2000) return; // debounce — one toast per 2s
    this.lastReadonlyToastAt = now;
    this.messageService.add({
      severity: 'info',
      summary: 'Edit EStamp Default Details is disabled',
      detail: 'These fields are locked. Enable "Edit EStamp Default Details" in account settings to make changes.',
      life: 4000,
    });
  }

  onProcessChange(evt) {
    this.process_type = evt.value;
    this.showPaymentDetails = false;

    let providers = this.getAvailableProviders();
    let paymentOption;

    if (this.is_wallet) {
      paymentOption = this.paymentbyWallet;
    } else if (providers.includes('RAZORPAY_GATEWAY')) {
      paymentOption = this.paymentbyRazorpay;
    } else if (providers.includes('HDFC_GATEWAY')) {
      paymentOption = 'HDFC_GATEWAY';
    } else {
      paymentOption = this.payLater;
    }
    if (paymentOption === this.payLater) {
      this.estampDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    } else {
      this.estampDetails.controls.paymentbySigner.setValue(true);
      this.storageService.getSignerValue.next(true);
    }
    this.estampDetails.controls.paymentMethod.setValue(paymentOption);

    if (evt.value === 'PRE_PROCUREMENT') {
      if (paymentOption !== this.paymentbyWallet) {
        this.storageService.getSignerValue.next(false);
      }
      if (this.inventoryPayment) {
        this.showPaymentDetails = true;
        this.validationForRazorypay = true;
        this.isPreProcurement = false;
      } else {
        this.showPaymentDetails = false;
        this.validationForRazorypay = false;
        this.isPreProcurement = true;
      }
    } else {
      this.storageService.getSignerValue.next(true);
      this.isPreProcurement = false;
      if (
        paymentOption === this.paymentbyRazorpay ||
        paymentOption === 'HDFC_GATEWAY'
      ) {
        this.showPaymentDetails = true;
        this.validationForRazorypay = true;
      } else {
        this.showPaymentDetails = false;
        this.validationForRazorypay = false;
      }
    }

    const panPattern = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$';

    this.documentDetailsArray().controls.forEach(
      (group: FormGroup, index: number) => {
        group.patchValue({ process_type: evt.value });

        // Always clear both fields first on process type change
        group.get('considerationPrice')?.setValue(null);
        group.get('stampDutyValue')?.setValue(null);
        this.stampAmountInWords[index] = null;
        this.considerationPriceInWords[index] = null;
        this.denominationData[index] = [];

        // Clear all validators first
        group.get('considerationPrice')?.clearValidators();
        group.get('stampDutyValue')?.clearValidators();

        // Re-trigger denomination API for all three process types when article is already selected
        const articleNumber = group.get('articleNumber')?.value;
        if (articleNumber) {
          setTimeout(() => {
            this.setStampValueAndConsiderationPrice(articleNumber, index);
          }, 100);
        }
        // Validators will be set inside setStampValueAndConsiderationPrice

        group
          .get('considerationPrice')
          ?.updateValueAndValidity({ emitEvent: false });
        group
          .get('stampDutyValue')
          ?.updateValueAndValidity({ emitEvent: false });

        const firstPan = group.get('first_party_pan');
        const secondPan = group.get('second_party_pan');
        if (evt.value === 'ESBTR') {
          firstPan?.setValidators([
            Validators.required,
            Validators.pattern(panPattern),
          ]);
          secondPan?.setValidators([
            Validators.required,
            Validators.pattern(panPattern),
          ]);
        } else {
          firstPan?.setValidators([Validators.pattern(panPattern)]);
          secondPan?.setValidators([Validators.pattern(panPattern)]);
        }
        firstPan?.updateValueAndValidity({ emitEvent: false });
        secondPan?.updateValueAndValidity({ emitEvent: false });
      },
    );

    this.updateRazorypayFieldValidation();
  }

  updateFormArray(eStamp) {
    this.denominationData = [];
    const formArray = this.estampDetails.get(
      'documentDetailsForm',
    ) as FormArray;

    const currentStateDefaults = this.setEstampDefaultDetails.filter(
      (item) => item.stateId === this.state_id,
    );

    if (currentStateDefaults.length > 0) {
      this.process_type = currentStateDefaults[0].process_type;
      this.estampDetails.patchValue({
        process_type: currentStateDefaults[0].process_type,
      });
    }

    formArray.controls.forEach((control, index) => {
      if (index < currentStateDefaults.length) {
        const defaultData = currentStateDefaults[index];
        const stampDutyData =
          eStamp.estamp_default_fields.state_wise_stamp_duty[index];

        if (stampDutyData) {
          const stampDutyValue = Array.isArray(
            stampDutyData.stamp_duty_amounts[0],
          )
            ? stampDutyData.stamp_duty_amounts[0][0]
            : stampDutyData.stamp_duty_amounts[0];

          const patchValues: any = {
            firstPartyName: eStamp.estamp_default_fields.first_party_name,
            secondPartyName: eStamp.estamp_default_fields.second_party_name,
            stampDutyPaidBy: eStamp.estamp_default_fields.stamp_duty_paid_by,
            purposeOfStampDuty: stampDutyData.description,
            articleNumber: stampDutyData.article_id,
            selectedState: this.defaultState[index],
            process_type: defaultData.process_type,
          };

          control.patchValue(patchValues);

          // For ON_THE_FLY call the API first, then re-apply default values after
          if (defaultData.process_type === 'ON_THE_FLY') {
            setTimeout(() => {
              this.setStampValueAndConsiderationPrice(
                stampDutyData.article_id,
                index,
              );
              // Re-apply default values after API binding
              setTimeout(() => {
                control.patchValue({
                  stampDutyValue: stampDutyValue,
                  considerationPrice: stampDutyData.consideration_amount,
                });
                this.stampAmountInWords[index] = stampDutyValue;
                this.considerationPriceInWords[index] =
                  stampDutyData.consideration_amount;
                this.denominationData[index] = [{ amount: stampDutyValue }];
                this.estampDetails.updateValueAndValidity();
                this.cdr.detectChanges();
              }, 800);
            }, 500);
          } else {
            // For PRE_PROCUREMENT / ESBTR â€” directly patch, no API call
            control.patchValue({
              stampDutyValue: stampDutyValue,
              considerationPrice: stampDutyData.consideration_amount,
            });
            this.stampAmountInWords[index] = stampDutyValue;
            this.considerationPriceInWords[index] =
              stampDutyData.consideration_amount;
            this.denominationData[index] = [{ amount: stampDutyValue }];
            this.estampDetails.updateValueAndValidity();
            this.cdr.detectChanges();
          }
        }
      }
    });
  }

  //------------------------------------------------------------------------------------------------------------------//

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  placeOrder() {
    this.submitted = true;
    if (
      this.estampDetails.valid &&
      this.estampDetails.value.referenceNumber != ''
    ) {
      this.sendEstampDetails();
    } else {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please enter the Reference Number to proceed',
      });
      //this.validateModalPopup.nativeElement.click()
    }
  }

  closeValidatePopup() {
    this.closeValidatePopupBtn.nativeElement.click();
  }

  gotoTemplate() {
    if (this.service === 'MULTIPLE-STAMP') {
      return;
    }
    this.estampDetailsData = [];
    const estampFormDetails = this.estampDetails.getRawValue();
    this.catUploadService.setEstampFormData(this.eStampAdditionalForm.value);
    estampFormDetails.documentDetailsForm.forEach(
      (estamp: any, index: number) => {
        if (['WB', 'MP'].includes(estamp.selectedState.state_code)) {
          const obj = this.eStampAdditionalForm.value?.[index];
          if (obj) {
            estamp = { ...estamp, ...obj };
          }
        }
        this.estampDetailsData.push({
          file: estamp.file,
          file_name: estamp.fileName,
          file_unique_id: estamp.fileUniqueId,
          document_to_be_estamp: estamp.documentToBeEstamp,
          is_use_same_previous_file: estamp.isUseSamePreviousFile,
          first_party_name: estamp.firstPartyName,
          first_party_pincode: estamp.First_Party_Pincode,
          first_party_official_document_type:
            estamp.First_Party_Official_Document_Type === 'OT'
              ? estamp.First_Party_Official_Document_Name
              : estamp.First_Party_Official_Document_Type,
          first_party_official_document_id:
            estamp.First_Party_Official_Document_ID,
          second_party_name: estamp.secondPartyName,
          second_party_pincode: estamp.Second_Party_Pincode,
          second_party_official_document_type:
            estamp.Second_Party_Official_Document_Type === 'OT'
              ? estamp.Second_Party_Official_Document_Name
              : estamp.Second_Party_Official_Document_Type,
          second_party_official_document_id:
            estamp.Second_Party_Official_Document_ID,
          stamp_duty_paid_by: estamp.stampDutyPaidBy,
          article_id: estamp.articleNumber || null,
          stamp_duty_amount: Array.isArray(estamp.stampDutyValue)
            ? estamp.stampDutyValue[0]
            : estamp.stampDutyValue || 0,
          consideration_amount: estamp.considerationPrice,
          description: estamp.purposeOfStampDuty || '',
          execution_date: estamp.execution_date.getTime(),
          process_type: estamp.process_type,
        });
      },
    );

    this.estampDetailsData.page = this.backValue;
    if (this.isEstamped) {
      this.estampDetailsData.selectedState =
        estampFormDetails.documentDetailsForm[0].selectedState;
      this.estampDetailsData.branch = this.selectedBranch;
    }
    this.estampDetailsData.isDefault = this.isDefault;
    this.estampDetailsData.isEstamped = this.isEstamped;
    this.estampChange.emit(this.estampDetailsData);
  }

  goToEsign() {
    this.submitted = true;
    const documentToBeStamped =
      this.service === 'MULTIPLE-STAMP'
        ? this.isEstamped && this.isAnyDocumentToBeStampedSelected()
        : this.isEstamped;
    this.storageService.setDocumentToBeStamped(documentToBeStamped);
    if (this.isEstamped) {
      const isFormInvalid =
        this.service === 'MULTIPLE-STAMP'
          ? !this.areStampedDocumentsValid()
          : this.estampDetails.invalid;

      if (isFormInvalid) {
        return;
      } else {
        this.estampDetailsData = [];
        const estampFormDetails = this.estampDetails.getRawValue();
        const dataToSave = {
          additionalFields: this.eStampAdditionalForm.value,
          savedReferenceNumber: estampFormDetails.referenceNumber,
        };
        this.catUploadService.setEstampFormData(dataToSave);
        estampFormDetails.documentDetailsForm.forEach(
          (estamp: any, index: number) => {
            if (['WB', 'MP'].includes(estamp.selectedState.state_code)) {
              const obj = this.eStampAdditionalForm.value?.[index];
              if (obj) {
                estamp = { ...estamp, ...obj };
              }
            }
            this.estampDetailsData.push({
              file: estamp.file,
              file_name: estamp.fileName,
              file_unique_id: estamp.fileUniqueId,
              document_to_be_estamp: estamp.documentToBeEstamp,
              is_use_same_previous_file: estamp.isUseSamePreviousFile,
              first_party_name: estamp.firstPartyName || 'NA',
              first_party_pincode: estamp.First_Party_Pincode,
              first_party_official_document_type:
                estamp.First_Party_Official_Document_Type === 'OT'
                  ? estamp.First_Party_Official_Document_Name
                  : estamp.First_Party_Official_Document_Type,
              first_party_official_document_id:
                estamp.First_Party_Official_Document_ID,
              second_party_name: estamp.secondPartyName || 'NA',
              second_party_pincode: estamp.Second_Party_Pincode,
              second_party_official_document_type:
                estamp.Second_Party_Official_Document_Type === 'OT'
                  ? estamp.Second_Party_Official_Document_Name
                  : estamp.Second_Party_Official_Document_Type,
              second_party_official_document_id:
                estamp.Second_Party_Official_Document_ID,
              stamp_duty_paid_by: estamp.stampDutyPaidBy || 'first_party_name',
              article_id: estamp.articleNumber || '',
              stamp_duty_amount: Array.isArray(estamp.stampDutyValue)
                ? estamp.stampDutyValue[0]
                : estamp.stampDutyValue || 0,
              consideration_amount: estamp.considerationPrice,
              description: estamp.purposeOfStampDuty,
              execution_date: estamp.execution_date.getTime(),
              process_type: estamp.process_type,
              first_party_pan: estamp.first_party_pan,
              second_party_pan: estamp.second_party_pan,
            });
            this.storageService.setProcessType(estamp.process_type);
          },
        );

        this.estampDetailsData.page = 'esign';
        if (this.isEstamped) {
          this.estampDetailsData.selectedState =
            estampFormDetails.documentDetailsForm[0].selectedState;
          this.estampDetailsData.branch = this.selectedBranch;
        }
        this.estampDetailsData.isDefault = this.isDefault;
        this.estampDetailsData.isEstamped = this.isEstamped;
        this.estampDetailsData.referenceNumber =
          this.estampDetails.value.referenceNumber;
        this.estampChange.emit(this.estampDetailsData);
      }
    } else {
      this.estampDetailsData = [];
      this.estampDetailsData.page = 'esign';
      this.estampDetailsData.isDefault = this.isDefault;
      this.estampDetailsData.isEstamped = this.isEstamped;
      this.estampDetailsData.referenceNumber =
        this.estampDetails.value.referenceNumber;
      this.estampDetailsData.documentDetailsForm =
        this.estampDetails.getRawValue().documentDetailsForm;
      this.estampChange.emit(this.estampDetailsData);
    }
  }

  sendEstampDetails() {
    this.estampData = this.estampDetails.getRawValue();
    if (this.isOperationalNeslContract) {
      this.estampData.documentDetailsForm =
        this.estampData.documentDetailsForm.map((detail) => ({
          ...detail,
          process_type: 'ON_THE_FLY',
        }));
      this.process_type = 'ON_THE_FLY';
    }
    const isWalletSelected =
      this.estampData.paymentMethod === this.paymentbyWallet;
    if (
      (!this.showPayment || this.process_type !== 'ON_THE_FLY') &&
      !isWalletSelected
    ) {
      this.estampData.paymentbySigner = false;
      this.estampData.paymentMethod = this.payLater;
      this.storageService.getSignerValue.next(false);
    }
    this.estampData.page = 'confirmation';
    this.estampChange.emit(this.estampData);
  }

  setDefaultArticles() {
    if (this.isDefault && this.showEstampSettings) {
      // Add showEstampSettings check
      const currentStateDefaults = this.setEstampDefaultDetails.filter(
        (item) => item.stateId === this.state_id,
      );

      if (currentStateDefaults.length > 0) {
        const filteredArray2 = this.articles[0].filter((item2) =>
          this.setEstampDefaultDetails.some(
            (item1) =>
              item1.articleNumber === item2.id &&
              item1.stateId === this.state_id,
          ),
        );
        if (filteredArray2.length != 0) {
          this.articles[0] = filteredArray2;
        }
      }
    }
  }

  getArticles(id): Observable<any> {
    let queryParams = { state_code: id };
    this.estampDetails.controls.state_code.setValue(id);

    return this.estampService.getArticles(queryParams).pipe(
      tap((resp) => {
        if (resp.status) {
          if (!this.articles[0]) {
            this.articles[0] = [];
          }
          this.articles[0] = resp['content'];
          for (let i = 1; i < this.documentDetailsArray().length; i++) {
            this.articles[i] = [...this.articles[0]];
          }
          //-------------------------Need to change the article code For HDFC---------------------//

          const host = window.location.host;

          if (this.organisationId === 'HDHO') {
            const host = window.location.host;
            let allowedIds = [];
            switch (host) {
              case 'uat.doqfy.in':
                allowedIds = [22340, 22341, 4146, 4142]; // FOR UAT
                break;
              case 'prod.doqfy.in':
                allowedIds = [4010, 4006, 4043, 1993]; // FOR PROD
                break;
              default:
                console.log(`Unknown host: ${host}`);
            }

            const filteredArticles = this.articles[0].filter((article) =>
              allowedIds.includes(article.id),
            );
            for (let i = 0; i < this.documentDetailsArray().length; i++) {
              this.articles[i] = [...filteredArticles];
            }
            //this.articles[0] = filteredArticles;
          }

          this.setDefaultArticles();

          //--------------------------------------------------------------------------------------------//
          for (let i = 0; i < this.documentDetailsArray().length; i++) {
            if (this.articles[i]) {
              this.articles[i].forEach((element, index) => {
                let articleDisplay =
                  element.article_code + ' ' + element.article_name;
                element['articleDisplay'] = articleDisplay;
              });
            }
          }
          let estampLength =
            this.estampDetails.controls['documentDetailsForm'].value.length;
          if (
            !this.custom &&
            this.estamp_default_fields &&
            this.estamp_default_fields.article_id &&
            estampLength < 2 &&
            this.estampData === undefined
          ) {
            this.documentDetailsArray()
              .at(0)
              .get('articleNumber')
              ?.setValue(this.estamp_default_fields.article_id);
            this.setStampValueAndConsiderationPrice(
              this.estamp_default_fields.article_id,
              0,
            );
          } else if (
            !this.custom &&
            this.estamp_default_fields &&
            this.estamp_default_fields.article_id &&
            this.estampData !== undefined &&
            this.estampData.length === 0
          ) {
            this.documentDetailsArray()
              .at(0)
              .get('articleNumber')
              ?.setValue(this.estamp_default_fields.article_id);
            this.setStampValueAndConsiderationPrice(
              this.estamp_default_fields.article_id,
              0,
            );
          }
          setTimeout(() => this.cdr.detectChanges(), 0);
        }
      }),
    );
  }

  // *------------------------------- eStamp Details --------------------------------------------*/
  removeDetails(index: number) {
    const formGroup = this.documentDetailsArray().at(index);
    const estampId = formGroup.get('estamp_id')?.value;

    if (estampId) {
      this.catUploadService.deleteDraftItem(estampId, 'estamp').subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            detail: 'Draft item removed successfully',
          });
          this.performLocalRemoval(index);
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            detail: 'Failed to delete draft item',
          });
        },
      });
    } else {
      this.performLocalRemoval(index);
    }
  }

  // Keep the UI logic separate to avoid duplication
  performLocalRemoval(index: number) {
    this.isConsiderationPriceValid.splice(index, 1);
    this.considerationPriceInWords.splice(index, 1);
    this.documentDetailsArray().removeAt(index);
    delete this.uploadedFileObjects[index];
  }

  // Separate the local UI logic
  executeLocalRemoval(index: number) {
    this.isConsiderationPriceValid.splice(index, 1);
    this.considerationPriceInWords.splice(index, 1);
    this.documentDetailsArray().removeAt(index);
    delete this.uploadedFileObjects[index];
  }

  documentDetailsArray(): FormArray {
    return this.estampDetails.get('documentDetailsForm') as FormArray;
  }

  setDefaultArticle() {
    var estampLength =
      this.estampDetails.controls['documentDetailsForm'].value.length - 1;
    // Handle default article binding when isDefault is true
    if (this.isDefault === true) {
      this.bindDefaultArticle(estampLength);
    }

    this.articles[estampLength] = this.articles[0] ? [...this.articles[0]] : [];
    this.denominationData[estampLength] = [];
    this.getEstampIndividualFields(this.stateSelected.state_code, estampLength);
  }

  addNewDetails() {
    this.estampLength =
      this.estampDetails.controls['documentDetailsForm'].value.length;
    const missingFileIndex = this.getMissingFileIndex();
    if (missingFileIndex !== -1) {
      this.messageService.add({
        severity: 'warn',
        detail: `Please select a file for E-stamp ${missingFileIndex + 1} before adding a new stamp.`,
      });
      return;
    }

    if (!this.isFormValidForMultiStamp()) {
      const docArray = this.documentDetailsArray();
      for (let i = 0; i < docArray.length; i++) {
        const ctrl = docArray.at(i);
        if (!ctrl.get('documentToBeEstamp')?.value) continue;
        const processType = ctrl.getRawValue().process_type;
        if (
          ctrl.get('considerationPrice')?.invalid &&
          processType !== 'PRE_PROCUREMENT' &&
          processType !== 'ESBTR'
        ) {
          this.messageService.add({
            severity: 'warn',
            detail: `Please enter consideration price for E-Stamp ${i + 1}.`,
          });
          return;
        }
        if (ctrl.get('stampDutyValue')?.invalid) {
          this.messageService.add({
            severity: 'warn',
            detail: `Please enter stamp duty value for E-Stamp ${i + 1}.`,
          });
          return;
        }
        if (ctrl.invalid) {
          this.messageService.add({
            severity: 'warn',
            detail: `Please fill all mandatory fields for E-Stamp ${i + 1} before adding a new stamp.`,
          });
          return;
        }
      }
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill all the Stamp details before adding New Stamp',
      });
      return;
    }

    // Validate consideration amount for all existing stamps before proceeding
    const docArray = this.documentDetailsArray();
    for (let i = 0; i < docArray.length; i++) {
      const ctrl = docArray.at(i);
      if (!ctrl.get('documentToBeEstamp')?.value) continue;
      const cp = ctrl.get('considerationPrice');
      if (
        cp &&
        (cp.value === null || cp.value === '' || cp.value === undefined)
      ) {
        this.messageService.add({
          severity: 'warn',
          detail: `Consideration Amount is mandatory for E-Stamp ${i + 1}.`,
        });
        return;
      }
    }

    // Check if we have reached the limit of available defaults
    const currentStateDefaults = this.setEstampDefaultDetails.filter(
      (item) => item.stateId === this.state_id,
    );

    // Show message only once when user first adds a stamp beyond the default count
    if (
      currentStateDefaults.length > 0 &&
      this.estampLength >= currentStateDefaults.length &&
      this.showEstampSettings &&
      this.isDefault &&
      !this.defaultLimitMessageShown
    ) {
      this.defaultLimitMessageShown = true;
      this.messageService.add({
        severity: 'info',
        detail: `Only ${currentStateDefaults.length} default configurations available for this state. Additional stamps will not have default values.`,
        life: 2000,
      });
    }

    this.isConsiderationPriceValid.push(true);
    this.considerationPriceInWords.push(0);
    if (
      !this.isFormValidExcludingPayeeFields() &&
      this.estampDetails.controls['documentDetailsForm'].value.length === 0
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill all the Stamp details before adding New',
      });
    }

    if (this.estampLength == 0) {
      this.readOnlyName.push(false);
      this.documentDetailsArray().push(this.initDetails());

      // For custom mode or when no defaults, ensure full articles list
      if (!this.isDefault || !this.showEstampSettings) {
        this.getArticles(this.stateSelected.state_code).subscribe(
          (response) => {
            this.articles[this.estampLength] = response?.content || [];
          },
        );
      } else {
        this.articles[this.estampLength] = this.articles[0]
          ? [...this.articles[0]]
          : [];
      }

      this.denominationData[this.estampLength] = [];
      this.getEstampIndividualFields(
        this.stateSelected.state_code,
        this.estampLength,
      );
    } else if (
      (this.service === 'MULTIPLE-STAMP'
        ? this.isFormValidForMultiStamp()
        : this.estampDetails.controls['documentDetailsForm'].valid) &&
      (this.estampLength <= 4 ||
        this.service === 'MULTIPLE-STAMP' ||
        this.sync_second_party_and_price)
    ) {
      this.documentDetailsArray().value.forEach((element, index) => {
        this.isConsiderationPriceValid[index] = true;

        if (!element.documentToBeEstamp) return;

        if (
          element.considerationPrice === null ||
          element.considerationPrice === '' ||
          element.considerationPrice === undefined
        ) {
          this.isConsiderationPriceValid[index] = false;
        }
      });

      let nextStep = true;
      this.isConsiderationPriceValid.forEach((element) => {
        if (!element) {
          nextStep = false;
          return;
        }
      });

      if (!nextStep) {
        const docLen = this.documentDetailsArray().length;
        for (let i = 0; i < docLen; i++) {
          if (!this.isConsiderationPriceValid[i]) {
            this.messageService.add({
              severity: 'warn',
              detail: `Please enter consideration price for E-Stamp ${i + 1}.`,
            });
            break;
          }
        }
        return;
      }

      const estampDetailsData = this.documentDetailsArray().value;
      this.readOnlyName.push(true);

      // Add new form control
      this.documentDetailsArray().push(this.repeatDetails());

      if (this.sync_second_party_and_price) {
        this.considerationPriceInWords[this.estampLength] =
          this.considerationPriceInWords[0];
      }

      // Check if defaults exist for current state and populate the new form
      if (this.isDefault && this.showEstampSettings) {
        this.populateDefaultsForNewStamp();
      } else {
        // For custom mode, ensure full articles list
        this.getArticles(this.stateSelected.state_code).subscribe(
          (response) => {
            this.articles[this.estampLength] = response?.content || [];
          },
        );
      }

      this.setDefaultArticle();
    } else if (this.estampLength > 4) {
      this.viewBulk();
    } else {
      // Form is invalid — surface the first specific field error to the user
      const docArray = this.documentDetailsArray();
      for (let i = 0; i < docArray.length; i++) {
        const ctrl = docArray.at(i);
        if (!ctrl.get('documentToBeEstamp')?.value) continue;
        if (ctrl.get('considerationPrice')?.invalid) {
          this.messageService.add({
            severity: 'warn',
            detail: `Consideration Amount is mandatory for E-Stamp ${i + 1}.`,
          });
          return;
        }
        if (ctrl.invalid) {
          this.messageService.add({
            severity: 'warn',
            detail: `Please fill all mandatory fields for E-Stamp ${i + 1} before adding a new stamp.`,
          });
          return;
        }
      }
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill all the Stamp details before adding a new stamp.',
      });
    }
  }
  isFormValidForMultiStamp(): boolean {
    if (this.service !== 'MULTIPLE-STAMP') {
      return this.isFormValidExcludingPayeeFields();
    }
    // For MULTIPLE-STAMP: only validate rows where documentToBeEstamp = true
    const docFormArray = this.documentDetailsArray();
    for (let i = 0; i < docFormArray.length; i++) {
      const control = docFormArray.at(i);
      const shouldBeStamped = control.get('documentToBeEstamp')?.value;
      if (shouldBeStamped && control.invalid) {
        return false;
      }
    }
    return true;
  }

  populateDefaultsForNewStamp() {
    const newIndex = this.estampLength;

    // Check if defaults exist for current state
    const currentStateDefaults = this.setEstampDefaultDetails.filter(
      (item) => item.stateId === this.state_id,
    );

    // Only populate defaults if we have default data for this index
    if (
      currentStateDefaults.length > 0 &&
      newIndex < currentStateDefaults.length
    ) {
      const defaultData = currentStateDefaults[newIndex];
      const formArray = this.documentDetailsArray();
      const newControl = formArray.at(newIndex);
      const selectedProcessType = formArray.at(0)?.getRawValue().process_type;

      if (newControl && defaultData.estampData) {
        // Set readonly status
        this.readOnlyDefault[newIndex] = !this.estamp_field_editable;

        // First, ensure articles are loaded for this state
        this.getArticles(this.stateSelected.state_code).subscribe(
          (response) => {
            // Filter articles based on default data ONLY when we have defaults for this index
            const filteredArray = this.articles[0].filter((item) =>
              this.setEstampDefaultDetails.some(
                (defaultItem) =>
                  defaultItem.articleNumber === item.id &&
                  defaultItem.stateId === this.state_id,
              ),
            );

            if (filteredArray.length > 0) {
              this.articles[newIndex] = filteredArray;
            } else {
              this.articles[newIndex] = this.articles[0]
                ? [...this.articles[0]]
                : [];
            }

            // Repeat rows inherit the process type currently selected on the
            // first stamp. The saved default is only a fallback when that value
            // has not been set yet.
            const processType =
              selectedProcessType || defaultData.process_type;
            this.process_type = processType;
            // Now populate form with default values
            const isInventory =
              processType === 'PRE_PROCUREMENT' || processType === 'ESBTR';
            newControl.patchValue({
              firstPartyName: defaultData.estampData.first_party_name,
              secondPartyName: defaultData.estampData.second_party_name,
              stampDutyPaidBy: defaultData.estampData.stamp_duty_paid_by,
              stampDutyValue:
                defaultData.stampDutyValue ?? (isInventory ? 0 : null),
              considerationPrice:
                defaultData.considerationPrice ?? (isInventory ? 0 : null),
              articleNumber: defaultData.articleNumber,
              selectedState: this.stateSelected,
              purposeOfStampDuty: defaultData.description,
              process_type: processType,
            });

            this.estampDetails.patchValue({
              process_type: processType,
            });

            if (this.sync_second_party_and_price) {
              const firstStamp = this.documentDetailsArray().at(0);
              newControl.patchValue(
                {
                  secondPartyName: firstStamp.get('secondPartyName')?.value,
                  considerationPrice: firstStamp.get('considerationPrice')?.value,
                  execution_date: firstStamp.get('execution_date')?.value,
                },
                { emitEvent: false },
              );
            }

            // Set denomination data
            const value = {
              amount: defaultData.stampDutyValue,
            };
            this.denominationData[newIndex] = [value];
            this.stampAmountInWords[newIndex] = defaultData.stampDutyValue;
            const draftData = this.storageService.getDraftData();
            if (draftData && draftData.order.id === this.currentOrderId) {
              this.draftLoaded = true;
            }
            // Set stamp value and consideration price after a short delay
            setTimeout(() => {
              this.setStampValueAndConsiderationPrice(
                defaultData.articleNumber,
                newIndex,
              );
              if (this.sync_second_party_and_price) {
                const firstStampPrice = this.documentDetailsArray()
                  .at(0)
                  .get('considerationPrice')?.value;
                this.documentDetailsArray()
                  .at(newIndex)
                  .get('considerationPrice')
                  ?.setValue(firstStampPrice, { emitEvent: false });
                this.considerationPriceInWords[newIndex] =
                  this.considerationPriceInWords[0];
              }
              this.estampDetails.updateValueAndValidity();
              this.cdr.detectChanges();
            }, 100);
          },
        );
      }
    } else if (this.sync_second_party_and_price && newIndex > 0) {
      const formArray = this.documentDetailsArray();
      const previousStamp = formArray.at(newIndex - 1).getRawValue();
      const newControl = formArray.at(newIndex);

      newControl.patchValue(
        {
          firstPartyName: previousStamp.firstPartyName,
          secondPartyName: previousStamp.secondPartyName,
          stampDutyPaidBy: previousStamp.stampDutyPaidBy,
          purposeOfStampDuty: previousStamp.purposeOfStampDuty,
          articleNumber: previousStamp.articleNumber,
          stampDutyValue: previousStamp.stampDutyValue,
          considerationPrice: previousStamp.considerationPrice,
          selectedState: previousStamp.selectedState,
          process_type: previousStamp.process_type,
          execution_date: previousStamp.execution_date,
        },
        { emitEvent: false },
      );

      this.readOnlyDefault[newIndex] = !this.estamp_field_editable;
      this.articles[newIndex] = this.articles[newIndex - 1]
        ? [...this.articles[newIndex - 1]]
        : this.articles[0]
          ? [...this.articles[0]]
          : [];
      this.denominationData[newIndex] = this.denominationData[newIndex - 1]
        ? [...this.denominationData[newIndex - 1]]
        : [];
      this.stampAmountInWords[newIndex] = this.stampAmountInWords[newIndex - 1];
      this.considerationPriceInWords[newIndex] =
        this.considerationPriceInWords[newIndex - 1];
    } else {
      // No more defaults available or no defaults for current state, set readonly to false
      this.readOnlyDefault[newIndex] = false;

      // Load all articles for this state WITHOUT filtering
      this.getArticles(this.stateSelected.state_code).subscribe((response) => {
        this.articles[newIndex] = response?.content || [];
      });

      this.denominationData[newIndex] = [];
    }
  }

  // New method to bind only the article based on index
  private bindDefaultArticle(currentIndex: number) {
    // Check if API response data exists
    if (
      this.estamp_default_fields[0]?.estamp_default_fields
        ?.state_wise_stamp_duty
    ) {
      const stampDutyData =
        this.estamp_default_fields[0].estamp_default_fields
          .state_wise_stamp_duty;

      // Get the article based on current index (0-based indexing)
      if (stampDutyData[currentIndex]) {
        const selectedStampDuty = stampDutyData[currentIndex];

        // Get the form control at the current index
        const currentFormControl = this.documentDetailsArray().at(currentIndex);

        if (currentFormControl) {
          // Only bind the article ID - this will trigger onArticleNumberChange
          currentFormControl.patchValue({
            articleNumber: selectedStampDuty.article_id,
          });
        }
        this.onArticleNumberChange(
          { value: selectedStampDuty.article_id },
          currentIndex,
        );
      } else {
        console.warn(`No stamp duty data available for index ${currentIndex}`);
      }
    } else {
      console.warn('API response data not available or incomplete');
    }
  }

  noLeadingSpacesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Check if the value starts with spaces
      if (value && /^\s/.test(value)) {
        return { noLeadingSpaces: true };
      }

      return null;
    };
  }

  notOnlyNumbersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Check if the value contains only numbers or numbers with spaces afterward
      if (value && (/^\d+$/.test(value) || /^\d+\s+$/.test(value))) {
        return { notOnlyNumbers: true };
      }

      return null;
    };
  }

  isFormValidExcludingPayeeFields(): boolean {
    const controls = this.estampDetails.controls;
    for (const key in controls) {
      if (key === 'documentDetailsForm') {
        if (controls[key].invalid) return false;
      } else if (
        key !== 'payeeName' &&
        key !== 'payeeEmail' &&
        key !== 'payeeMobileNumber'
      ) {
        if (controls[key].invalid) return false;
      }
    }
    return true;
  }

  initDetails() {
    return this.formBuilder.group({
      isUseSamePreviousFile: new FormControl(false),
      fileUniqueId: new FormControl(null),
      documentToBeEstamp: new FormControl(true),
      file: new FormControl(null),
      fileName: new FormControl(null),
      firstPartyName: new FormControl('', [
        Validators.required,
        noSpacesValidator(),
        Validators.maxLength(50),
        this.notOnlyNumbersValidator(),
        this.noLeadingSpacesValidator(),
      ]),
      secondPartyName: new FormControl('', [
        Validators.required,
        noSpacesValidator(),
        Validators.maxLength(50),
        this.notOnlyNumbersValidator(),
        this.noLeadingSpacesValidator(),
      ]),
      stampDutyPaidBy: new FormControl('', [Validators.required]),
      stampDutyValue: new FormControl(null, [
        Validators.required,
        this.notOnlyZeroValidator,
      ]),
      purposeOfStampDuty: new FormControl('', [
        Validators.required,
        this.noLeadingSpacesValidator(),
        noScriptTagValidator(),
      ]),
      NoOfCopies: new FormControl(1, [Validators.required]),
      articleNumber: new FormControl('', [Validators.required]),
      considerationPrice: new FormControl(null, [Validators.required]),
      execution_date: new FormControl(this.today, [Validators.required]),
      selectedState: new FormControl(this.stateSelected, [Validators.required]),
      selectBranch: new FormControl(this.selectedBranch, [Validators.required]),
      process_type: new FormControl(
        this.isOperationalNeslContract ? 'ON_THE_FLY' : null,
        [Validators.required],
      ),
      first_party_pan: ['', [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      second_party_pan: [
        '',
        [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')],
      ],
      place: [''],
    });
  }

  repeatDetails() {
    const stamp1ProcessType = this.documentDetailsArray()
      .at(0)
      .getRawValue().process_type;

    return this.formBuilder.group({
      isUseSamePreviousFile: new FormControl(false),
      fileUniqueId: new FormControl(null),
      documentToBeEstamp: new FormControl(true),
      file: new FormControl(null),
      fileName: new FormControl(null),
      firstPartyName: new FormControl(
        this.estampDetails.controls['documentDetailsForm'].value[0]
          .firstPartyName,
        [
          Validators.required,
          noSpacesValidator(),
          Validators.maxLength(50),
          this.notOnlyNumbersValidator(),
          this.noLeadingSpacesValidator(),
        ],
      ),
      secondPartyName: new FormControl(
        this.estampDetails.controls['documentDetailsForm'].value[0]
          .secondPartyName,
        [
          Validators.required,
          noSpacesValidator(),
          Validators.maxLength(50),
          this.notOnlyNumbersValidator(),
          this.noLeadingSpacesValidator(),
        ],
      ),
      stampDutyPaidBy: new FormControl(
        this.estampDetails.controls['documentDetailsForm'].value[0]
          .stampDutyPaidBy,
        [Validators.required],
      ),
      stampDutyValue: new FormControl(null, [
        Validators.required,
        this.notOnlyZeroValidator,
      ]),
      purposeOfStampDuty: new FormControl('', [
        Validators.required,
        this.noLeadingSpacesValidator(),
      ]),
      NoOfCopies: new FormControl(1, [Validators.required]),
      articleNumber: new FormControl('', [Validators.required]),
      considerationPrice: new FormControl(
        this.sync_second_party_and_price
          ? this.estampDetails.controls['documentDetailsForm'].value[0]
              .considerationPrice
          : null,
        [Validators.required],
      ),
      execution_date: new FormControl(
        {
          value:
            this.estampDetails.controls['documentDetailsForm'].value[0]
              .execution_date,
          // When sync is enabled the Execution Date is only editable on the first
          // stamp detail; repeated (index 1+) stamps inherit and lock it.
          disabled: this.sync_second_party_and_price,
        },
        [Validators.required],
      ),
      selectBranch: new FormControl(
        { value: this.selectedBranch, disabled: true },
        [Validators.required],
      ),
      selectedState: new FormControl(
        {
          value:
            this.estampDetails.controls['documentDetailsForm'].value[0]
              .selectedState,
          disabled: true,
        },
        [Validators.required],
      ),
      // Inherit stamp 1's process_type â€” locked, cannot change
      process_type: new FormControl(
        { value: stamp1ProcessType, disabled: true },
        [Validators.required],
      ),
      first_party_pan: ['', [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      second_party_pan: [
        '',
        [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')],
      ],
      place: [''],
    });
  }
  notOnlyZeroValidator(control: AbstractControl) {
    if (control.value === 0) {
      return { notOnlyZero: true };
    }
    return null;
  }

  get isNeslMetadataContract(): boolean {
    const contractType = String(
      this.isDocumentType || this.storageService.getContractNumber() || '',
    );
    return ['001', '002'].includes(contractType);
  }

  get isOperationalNeslContract(): boolean {
    return (
      this.isDocumentType === '002' ||
      this.storageService.getContractNumber() === '002'
    );
  }

  isOnTheFlyAtIndex(index: number): boolean {
    return (
      this.documentDetailsArray().at(index)?.getRawValue()?.process_type ===
      'ON_THE_FLY'
    );
  }

  isNumberField(validators: any[] | undefined): boolean {
    return validators?.includes('number') ?? false;
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);

    // Check if the input value exceeds 13 characters
    if (event.target.value.length >= 13) {
      event.preventDefault(); // Prevent further input
    }

    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  numberOnlyForConsidPrice(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    // Check if the input value exceeds 13 characters

    if (event.target.value.length >= 13) {
      event.preventDefault(); // Prevent further input
    }

    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    // Get the pasted content
    const pastedContent = event.clipboardData?.getData('text');

    // Check if the pasted content length exceeds 13 characters
    if (pastedContent && pastedContent.length > 13) {
      event.preventDefault(); // Prevent pasting if length exceeds 13 characters
    }
    if (
      pastedContent.includes('.') ||
      pastedContent.includes(',') ||
      !/^\d+$/.test(pastedContent.trim())
    ) {
      event.preventDefault();
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Input',
        detail: 'Decimals are not accepted',
      });
      return;
    }
  }

  tobeEstamped(value: boolean) {
    this.isEstamped = value;
    this.storageService.setDocumentToBeStamped(value);
    let estampLength =
      this.estampDetails.controls['documentDetailsForm'].value.length;
    if (this.isEstamped && estampLength === 0) {
      this.addNewDetails();
      //  this.getDefaultFieldData(this.account_id)
    }
    if (this.isDefault) {
      this.tobeDefault(true);
    }
  }

  cancelBulkOption() {
    this.readOnlyName.push(true);
    this.documentDetailsArray().push(this.repeatDetails());
    this.setDefaultArticle();
    this.modalService.dismissAll();
  }

  goToBulkUpload() {
    if (this._location.path() == '/doqfy/cat-edit/form') {
      this.router.navigate(['/doqfy/cat-edit/bulk-upload']);
    } else if (!this.pathId) {
      this.router.navigate(['/doqfy/bulk-upload/form', 'cat-upload']);
    } else {
      this.router.navigate(['/doqfy/bulk-upload/form/e-stamp']);
    }
    this.modalService.dismissAll();
  }

  onArticleNumberChange(evt, i) {
    const documentDetail = this.documentDetailsArray().at(i);
    documentDetail.get('stampDutyValue').setValue(null);
    if (this.isOperationalNeslContract) {
      const currentConsideration = documentDetail.get('considerationPrice').value;
      documentDetail
        .get('considerationPrice')
        .setValue(currentConsideration ?? 0, { emitEvent: false });
    } else {
      documentDetail.get('considerationPrice').setValue(null);
    }

    if (!this.denominationData[i]) {
      this.denominationData[i] = [];
    }
    this.denominationData[i] = [];
    this.stampAmountInWords[i] = null;
    this.minStampValue[i] = null;
    this.readOnlyStampAmt = false;

    this.setStampValueAndConsiderationPrice(evt.value, i, false);
    if (
      this.isOperationalNeslContract &&
      Number(documentDetail.get('considerationPrice').value || 0) <= 0 &&
      this.stateSelected?.state_code
    ) {
      this.getStateDenomination(
        this.stateSelected.state_code,
        evt.value,
        0,
        i,
        this.account_id,
      );
    }

    this.cdr.detectChanges();
  }

  setStampValueAndConsiderationPrice(
    id,
    index,
    isDefaultLoad: boolean = false,
  ) {
    const documentDetail = this.documentDetailsArray().at(index);
    const currentProcessType = documentDetail.getRawValue().process_type;
    const isInventoryOrEsbtr =
      currentProcessType === 'PRE_PROCUREMENT' ||
      currentProcessType === 'ESBTR';

    // Runs for ON_THE_FLY, PRE_PROCUREMENT, and ESBTR — all call the denomination API
    documentDetail.get('considerationPrice')?.clearValidators();
    documentDetail.get('stampDutyValue')?.clearValidators();

    this.articles[0].forEach((article) => {
      if (article.id === id) {
        if (article.amount) {
          this.selectedArticleAmount[index] = article.amount;

          if (this.selectedArticleAmount[index]?.fix_stamp_duty) {
            const fixedStampDuty =
              this.selectedArticleAmount[index].fix_stamp_duty;
            documentDetail.get('stampDutyValue')?.setValue(fixedStampDuty);
            // Inventory/ESBTR: any value > 0 allowed; ON_THE_FLY: enforce API-driven minimum
            documentDetail
              .get('stampDutyValue')
              ?.setValidators(
                isInventoryOrEsbtr
                  ? [Validators.required, this.notOnlyZeroValidator]
                  : [Validators.min(fixedStampDuty)],
              );
            this.stampAmountInWords[index] = fixedStampDuty;
            this.minStampValue[index] = fixedStampDuty;
            if (!this.denominationData[index]) {
              this.denominationData[index] = [];
            }
            this.denominationData[index] = [{ amount: fixedStampDuty }];
          } else {
            const considerationPrice =
              documentDetail.get('considerationPrice')?.value ?? 0;
            if (considerationPrice > 0) {
              this.getStateDenomination(
                this.stateSelected.state_code,
                id,
                considerationPrice,
                index,
                this.account_id,
              );
            }
          }

          if (this.selectedArticleAmount[index]?.min_consideration_amount) {
            documentDetail
              .get('considerationPrice')
              ?.setValue(
                this.selectedArticleAmount[index].min_consideration_amount,
              );
            // For ON_THE_FLY: always call denomination API with min_consideration_amount,
            // even if the article has fix_stamp_duty (denomination is dynamically calculated).
            // For Inventory/ESBTR with fix_stamp_duty: use the article value directly.
            if (
              !isInventoryOrEsbtr ||
              !this.selectedArticleAmount[index]?.fix_stamp_duty
            ) {
              this.getStateDenomination(
                this.stateSelected.state_code,
                id,
                this.selectedArticleAmount[index].min_consideration_amount,
                index,
                this.account_id,
              );
            }
          }

          const validators = [Validators.required];
          if (
            this.selectedArticleAmount[index]?.min_consideration_amount !==
            undefined
          ) {
            validators.push(
              Validators.min(
                this.selectedArticleAmount[index].min_consideration_amount,
              ),
            );
          }
          if (
            this.selectedArticleAmount[index]?.max_consideration_amount !==
            undefined
          ) {
            validators.push(
              Validators.max(
                this.selectedArticleAmount[index].max_consideration_amount,
              ),
            );
          }
          documentDetail.get('considerationPrice')?.setValidators(validators);
        }

        if (this.estampData?.length) {
          documentDetail
            .get('considerationPrice')
            ?.setValue(this.estampData[0].consideration_amount);
          documentDetail
            .get('stampDutyValue')
            ?.setValue(this.selectedArticleAmount[index]?.fix_stamp_duty || 0);
        }

        if (this.isDefault && !this.draftLoaded) {
          if (this.defaultDescriptions && this.defaultDescriptions[index]) {
            documentDetail
              .get('purposeOfStampDuty')
              ?.setValue(this.defaultDescriptions[index]);
          } else {
            if (
              this.estamp_default_fields[0]?.estamp_default_fields
                ?.state_wise_stamp_duty
            ) {
              const stampDutyData =
                this.estamp_default_fields[0].estamp_default_fields
                  .state_wise_stamp_duty;
              if (
                stampDutyData[index] &&
                stampDutyData[index].article_id === id
              ) {
                documentDetail
                  .get('purposeOfStampDuty')
                  ?.setValue(stampDutyData[index].description);
              }
            }
          }
        }

        documentDetail
          .get('considerationPrice')
          ?.updateValueAndValidity({ emitEvent: false });
        documentDetail
          .get('stampDutyValue')
          ?.updateValueAndValidity({ emitEvent: false });

        if (this.isDefault && !this.draftLoaded) {
          this.setEstampDefaultDetails.forEach((ele) => {
            if (ele.articleNumber === id) {
              if (!this.denominationData[index]) {
                this.denominationData[index] = [];
              }

              const stampDutyValue =
                ele.stampDutyValue[0] || ele.stampDutyValue;

              documentDetail.get('stampDutyValue')?.setValue(stampDutyValue);
              documentDetail
                .get('considerationPrice')
                ?.setValue(ele.considerationPrice);

              this.considerationPriceInWords[index] = ele.considerationPrice;
              this.stampAmountInWords[index] = stampDutyValue;

              const value = { amount: stampDutyValue };
              this.denominationData[index] = [value];

              if (this.selectedArticleAmount[index]?.fix_stamp_duty) {
                documentDetail
                  .get('stampDutyValue')
                  ?.setValidators([
                    Validators.min(
                      this.selectedArticleAmount[index].fix_stamp_duty,
                    ),
                  ]);
                this.minStampValue[index] =
                  this.selectedArticleAmount[index].fix_stamp_duty;
              }

              const validators = [Validators.required];
              if (
                this.selectedArticleAmount[index]?.min_consideration_amount !==
                undefined
              ) {
                validators.push(
                  Validators.min(
                    this.selectedArticleAmount[index].min_consideration_amount,
                  ),
                );
              }
              if (
                this.selectedArticleAmount[index]?.max_consideration_amount !==
                undefined
              ) {
                validators.push(
                  Validators.max(
                    this.selectedArticleAmount[index].max_consideration_amount,
                  ),
                );
              }
              documentDetail
                .get('considerationPrice')
                ?.setValidators(validators);

              documentDetail
                .get('considerationPrice')
                ?.updateValueAndValidity({ emitEvent: false });
              documentDetail
                .get('stampDutyValue')
                ?.updateValueAndValidity({ emitEvent: false });
            }
          });
        }
      }
    });

    // Safety net: consideration price must always be required regardless of article data or mode
    const cpControl = documentDetail.get('considerationPrice');
    if (cpControl) {
      cpControl.addValidators(Validators.required);
      cpControl.updateValueAndValidity({ emitEvent: false });
    }
  }

  onPasteEstampInput(event: ClipboardEvent, controlName: string) {
    const pastedText = event.clipboardData?.getData('text') || '';
    const scriptPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;

    if (scriptPattern.test(pastedText)) {
      event.preventDefault(); // Prevent paste
      this.messageService.add({
        severity: 'error',
        summary: 'Security Alert',
        detail: 'Malicious content detected. Script tags are not allowed.',
        life: 3000,
      });
    }
  }

  onPasteDocumentInput(
    event: ClipboardEvent,
    controlName: string,
    index: number,
  ) {
    const pastedText = event.clipboardData?.getData('text') || '';
    const scriptPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;

    if (scriptPattern.test(pastedText)) {
      event.preventDefault(); // Prevent paste
      this.messageService.add({
        severity: 'error',
        summary: 'Security Alert',
        detail: 'Malicious content detected. Script tags are not allowed.',
        life: 3000,
      });
    }
  }

  onConsiderationPriceInput(event: any, index: number) {
    const documentDetail = this.documentDetailsArray().at(index);
    const articleNumber = documentDetail.get('articleNumber')?.value;
    const considerationPriceControl = documentDetail.get('considerationPrice');
    const selectedArticle = this.selectedArticleAmount[index];
    const isOnTheFly = this.isOnTheFlyAtIndex(index);

    // Runs for ON_THE_FLY, PRE_PROCUREMENT, and ESBTR — all trigger denomination API
    const matchedArticle = this.setEstampDefaultDetails.find(
      (item) => item.articleNumber === articleNumber,
    );

    considerationPriceControl.clearValidators();

    const validators = [Validators.required];
    if (selectedArticle?.min_consideration_amount !== undefined) {
      validators.push(Validators.min(selectedArticle.min_consideration_amount));
    } else if (matchedArticle) {
      const minConsideration = matchedArticle.considerationPrice;
      if (minConsideration && minConsideration > 0) {
        validators.push(Validators.min(matchedArticle.considerationPrice));
      }
    }

    if (selectedArticle?.max_consideration_amount !== undefined) {
      validators.push(Validators.max(selectedArticle.max_consideration_amount));
    }

    if (event === null) {
      this.isConsiderationPriceValid[index] = false;
      this.considerationPriceInWords[index] = null;
      if (
        selectedArticle &&
        (selectedArticle.fix_stamp_duty === undefined || isOnTheFly)
      ) {
        this.onConsidrPriceChange.next({
          articleId: documentDetail.get('articleNumber')?.value,
          event: 0,
          index: index,
        });
      }
      if (selectedArticle?.fix_stamp_duty === undefined || isOnTheFly) {
        documentDetail.get('stampDutyValue')?.setValue('');
        this.stampAmountInWords[index] = null;
      }
      return;
    }

    this.isConsiderationPriceValid[index] = true;
    this.considerationPriceInWords[index] = event;

    if (
      selectedArticle?.max_consideration_amount !== undefined &&
      event > selectedArticle.max_consideration_amount
    ) {
      if (selectedArticle.fix_stamp_duty === undefined || isOnTheFly) {
        documentDetail.get('stampDutyValue')?.setValue('');
        this.stampAmountInWords[index] = null;
      }
      considerationPriceControl?.setValidators(validators);
      considerationPriceControl?.updateValueAndValidity({ emitEvent: false });
      return;
    }

    if (considerationPriceControl.valid) {
      const articleId = documentDetail.get('articleNumber')?.value;
      if (
        (selectedArticle?.fix_stamp_duty === undefined || isOnTheFly) &&
        event !== null
      ) {
        this.onConsidrPriceChange.next({ articleId, event, index });
      } else if (selectedArticle === null && event !== null) {
        this.onConsidrPriceChange.next({ articleId, event, index });
      }
    } else {
      if (selectedArticle?.fix_stamp_duty === undefined || isOnTheFly) {
        documentDetail.get('stampDutyValue')?.setValue('');
        this.stampAmountInWords[index] = null;
      }
    }

    considerationPriceControl.setValidators(validators);
    considerationPriceControl.updateValueAndValidity({ emitEvent: false });
  }

  //-----------------------------------Select State and Branch -------------------------//
  getBranchDetails(id: number, patchForm: boolean = true): Observable<any> {
    const account_id = this.storageService.getAccountId() || null;

    return this.userDashboardService
      .getBranchListbyStateId(id, account_id)
      .pipe(
        tap((res: any) => {
          // Filter for active branches that are assigned to the user
          this.branchData[0] = res['content']
            .filter((element) => element.is_active === true)
            .filter((element) => this.userBranches.includes(element.id));

          const state = this.selectedState;
          if (this.branchData[0].length === 0) {
            this.messageService.add({
              severity: 'info',
              summary: 'Branch Not Allocated',
              detail: `Branch from the following State ${state.state_name} are not assigned to you.`,
            });
            return;
          }
          const selectedBranch = this.branchData[0].find(
            (u) => u.id === this.selectedBranch?.id,
          );
          if (!selectedBranch) {
            this.selectedBranch = this.branchData[0][0];
          } else {
            this.selectedBranch = selectedBranch;
          }
          this.setDefaultBranch({ value: this.selectedBranch }, patchForm);
          if (patchForm) {
            this.documentDetailsArray().controls.forEach((group: FormGroup) => {
              group.patchValue({
                selectBranch: this.selectedBranch,
              });
            });
          }
        }),
      );
  }

  getBranchDefault(id: number) {
    const account_id = this.storageService.getAccountId() || null;

    this.userDashboardService
      .getBranchListbyStateId(id, account_id)
      .subscribe((res) => {
        this.branchData[0] = res['content'];
      });
  }

  //--------------------Branch, State , execution Date , first party Name and Second party name should be same -----------------------------//

  onNameChange(i: number, value: string) {
    const documentDetailsFormArray = this.estampDetails.get(
      'documentDetailsForm',
    ) as FormArray;

    if (value === 'firstPartyName') {
      const name = this.documentDetailsArray().value[i].firstPartyName;
      documentDetailsFormArray.controls.forEach((control) => {
        control.patchValue({ firstPartyName: name });
      });
    } else if (value === 'secondPartyName') {
      const name = this.documentDetailsArray().value[i].secondPartyName;

      documentDetailsFormArray.controls.forEach((control) => {
        control.patchValue({ secondPartyName: name });
      });
    }
  }

  onExecutionDateChange(i: number) {
    const executionDate = this.documentDetailsArray().value[i].execution_date;
    this.documentDetailsArray()
      .at(i)
      .get('execution_date')
      ?.setValue(executionDate);

    const documentDetailsFormArray = this.estampDetails.get(
      'documentDetailsForm',
    ) as FormArray;
    documentDetailsFormArray.controls.forEach((control) => {
      control.patchValue({ execution_date: executionDate });
    });
  }

  getStateDetails() {
    this.userDashboardService.getStates().subscribe((res: any) => {
      this.stateData = Array.isArray(res['content']) ? res['content'] : [];
      if (this.isNeslMetadataContract) {
        const selectedState = this.stateData.find(
          (state) => state.id === this.stateSelected?.id,
        );
        this.stateSelected = selectedState || this.stateData[0] || null;
        if (!this.stateSelected) {
          this.documentDetailsArray().controls.forEach((group: FormGroup) => {
            group.patchValue({ selectedState: null, selectBranch: null });
          });
          this.articles = [];
          this.branchData = [];
          return;
        }
        this.state_id = this.stateSelected.id;
        this.documentDetailsArray().controls.forEach((group: FormGroup) => {
          group.patchValue({ selectedState: this.stateSelected });
        });
      }
      if (
        this.service === 'MULTIPLE-STAMP' &&
        this.isEstamped &&
        this.documentDetailsArray().length === 0
      ) {
        this.addNewDetails();
      }
      if (
        this.estampData !== undefined &&
        this.estampData.isEstamped &&
        this.estampData.length === 0
      ) {
        this.isEstamped = this.estampData.isEstamped;

        if (this.documentDetailsArray().length === 0) {
          this.addNewDetails();
        }
      } else if (this.estampData !== undefined && !this.estampData.isEstamped) {
        this.isEstamped = this.estampData.isEstamped;
      }

      if (
        this.estampData !== undefined &&
        this.estampData.isEstamped &&
        this.estampData.length > 0
      ) {
        this.stateSelected = this.estampData.selectedState;

        // First API call to get branch details
        this.getBranchDetails(this.estampData.selectedState.id).subscribe(
          (branchResponse) => {
            if (branchResponse) {
              // Second API call to get articles
              this.getArticles(
                this.estampData.selectedState.state_code,
              ).subscribe((articlesResponse) => {
                if (articlesResponse) {
                  this.documentDetailsArray().clear();
                  this.estampData.forEach((element, index) => {
                    if (!element.document_to_be_estamp) {
                      this.isConsiderationPriceValid.push(true);
                      this.considerationPriceInWords.push(0);
                      this.documentDetailsArray().push(this.initDetails());
                      const lastIndex = this.documentDetailsArray().length - 1;
                      this.articles[lastIndex] = this.articles[0]
                        ? [...this.articles[0]]
                        : [];
                      this.denominationData[lastIndex] = [];
                      this.documentDetailsArray()
                        .at(lastIndex)
                        .get('documentToBeEstamp')
                        ?.setValue(false);
                      this.onDocumentToBeEstamp(lastIndex);
                      // Patch file data
                      this.documentDetailsArray().at(lastIndex).patchValue({
                        file: element.file,
                        fileName: element.file_name,
                        fileUniqueId: element.file_unique_id,
                        isUseSamePreviousFile:
                          element.is_use_same_previous_file,
                        documentToBeEstamp: false,
                      });
                      if (element.file) this.fileSelectedMap[lastIndex] = true;
                      return;
                    }
                    this.documentDetailsArray().push(this.initDetails());
                    this.getEstampIndividualFields(
                      this.estampData.selectedState.state_code,
                      index,
                    );
                    const lastIndex = this.documentDetailsArray().length - 1;
                    const lastFormGroup =
                      this.documentDetailsArray().at(lastIndex);
                    
                    this.articles[lastIndex] = this.articles[0]
                      ? [...this.articles[0]]
                      : [];
                    this.isConsiderationPriceValid[lastIndex] = true;
                    this.isStampValueValid[lastIndex] = true;
                    this.considerationPriceInWords[lastIndex] =
                      element.consideration_amount;
                    this.stampAmountInWords[lastIndex] =
                      element.stamp_duty_amount;
                    //this.validateStampValueConsiderationPriceAfterBackClick(this.estampData[lastIndex].article_id, lastIndex)
                    this.documentDetailsArray().at(lastIndex).patchValue({
                      fileUniqueId: element.file_unique_id,
                      documentToBeEstamp: element.document_to_be_estamp,
                      file: element.file,
                      fileName: element.file_name,
                      isUseSamePreviousFile: element.is_use_same_previous_file,
                      firstPartyName: element.first_party_name,
                      secondPartyName: element.second_party_name,
                      stampDutyPaidBy: element.stamp_duty_paid_by,
                      purposeOfStampDuty: element.description,
                      selectedState: this.estampData.selectedState,
                      articleNumber: element.article_id,
                      stampDutyValue: element.stamp_duty_amount,
                      considerationPrice: element.consideration_amount,
                      execution_date: this.today,
                      process_type: element.process_type,
                      first_party_pan: element.first_party_pan || '',
                      second_party_pan: element.second_party_pan || '',
                    });
                    this.fileSelectedMap[lastIndex] = true;
                  });
                  console.log();
                } else {
                  console.error('Failed to get articles.');
                }
              });
            } else {
              console.error('Failed to get branch details.');
            }
          },
        );
      }

      if (
        this.estampData !== undefined &&
        this.estampData.documentDetailsForm !== undefined &&
        this.estampData.documentDetailsForm.length > 0
      ) {
        this.stateSelected =
          this.estampData.documentDetailsForm[0].selectedState;

        // First API call to get branch details
        this.estampData.documentDetailsForm[0].selectedState.id
          ? this.getBranchDetails(
              this.estampData.documentDetailsForm[0].selectedState.id,
            ).subscribe((branchResponse) => {
              if (branchResponse) {
                // Second API call to get articles
                this.getArticles(
                  this.estampData.documentDetailsForm[0].selectedState
                    .state_code,
                ).subscribe((articlesResponse) => {
                  if (articlesResponse) {
                    // Both responses are available, proceed with the forEach loop
                    this.documentDetailsArray().clear();
                    this.estampData.documentDetailsForm.forEach((element) => {
                      this.documentDetailsArray().push(this.initDetails());
                      const lastIndex = this.documentDetailsArray().length - 1;
                      const lastFormGroup =
                        this.documentDetailsArray().at(lastIndex);
                      this.articles[lastIndex] = this.articles[0]
                        ? [...this.articles[0]]
                        : [];
                      this.isConsiderationPriceValid[lastIndex] = true;
                      this.isStampValueValid[lastIndex] = true;
                      this.considerationPriceInWords[lastIndex] =
                        element.considerationPrice;
                      this.stampAmountInWords[lastIndex] =
                        element.stampDutyValue;
                      this.documentDetailsArray().at(lastIndex).patchValue({
                        firstPartyName: element.firstPartyName,
                        secondPartyName: element.secondPartyName,
                        stampDutyPaidBy: element.stampDutyPaidBy,
                        purposeOfStampDuty: element.purposeOfStampDuty,
                        selectedState:
                          this.estampData.documentDetailsForm[0].selectedState,
                        articleNumber: element.articleNumber,
                        stampDutyValue: element.stampDutyValue,
                        considerationPrice: element.considerationPrice,
                        execution_date: this.today,
                        process_type: element.process_type,
                      });
                    });
                  } else {
                    console.error('Failed to get articles.');
                  }
                });
              } else {
                console.error('Failed to get branch details.');
              }
            })
          : this.addNewDetails();
      }

      setTimeout(() => {
        this.estampData === undefined
          ? (this.isDefault = this.storageService.getEstampDefault())
          : (this.isDefault = this.estampData.isDefault);

        if (this.isOperationalNeslContract) {
          this.isDefault = false;
          this.default = false;
          this.custom = true;
          this.getBranchDefault(this.stateSelected.id);
          this.getArticles(this.stateSelected.state_code).subscribe(
            () => undefined,
          );
          this.getStateDenominationForProcessOptions(
            this.stateSelected.state_code,
          );
        } else if (this.isDefault === true) {
          this.default = true;
          this.getDefaultFieldData(this.account_id);
        } else {
          this.custom = true;
          this.getBranchDefault(this.stateSelected.id);
          this.getArticles(this.stateSelected.state_code).subscribe(
            () => undefined,
          );
        }
        this.checkAndPopulateDraft();
        this.cdr.detectChanges();
      }, 0);
    });
    if (!this.isOperationalNeslContract && this.stateSelected) {
      this.getBranchDefault(this.stateSelected.id);
      this.getArticles(this.stateSelected.state_code).subscribe(() => undefined);
      if (this.stateSelected.state_code) {
        this.getStateDenominationForProcessOptions(
          this.stateSelected.state_code,
        );
      }
    }
  }

  setStateData(i: number) {
    this.branchData[i] = [];
    this.considerationPriceInWords[i] = 0;
    this.stampAmountInWords[i] = null;
    this.selectedArticleAmount[i] = null;
    const state = this.documentDetailsArray().value[i].selectedState;
    this.formEstampData = [];
    this.getEstampIndividualFields(state.state_code, this.estampLength - 1);

    this.documentDetailsArray().at(i).get('selectedState')?.setValue(state);
    const documentDetailsFormArray = this.estampDetails.get(
      'documentDetailsForm',
    ) as FormArray;
    documentDetailsFormArray.controls.forEach((control) => {
      control.patchValue({ selectedState: state });
    });

    this.storageService.setState(state);
    this.storageService.stateChange.next(state);
    this.getBranchDetails(state.id).subscribe((response) => {});
    this.stateSelected = state;

    if (i === 0) {
      this.state_id = state.id;
    }

    if (i === 0) {
      const processTypeControl = this.documentDetailsArray().at(0).get('process_type');
      if (this.estamp_field_editable) {
        if (processTypeControl?.disabled) {
          processTypeControl.enable({ emitEvent: false });
        }
        processTypeControl?.setValue(null, { emitEvent: false });
        this.readOnlyDefault[0] = false;
      }
      this.stateWasManuallyChanged = true;
    }

    // Rebuild processOptions based on state denomination API response
    this.getArticles(state.state_code).subscribe((response) => {});
    this.getStateDenominationForProcessOptions(state.state_code);

    this.documentDetailsArray()
      .at(0)
      .get('considerationPrice')
      ?.clearValidators();
    this.documentDetailsArray()
      .at(0)
      .get('considerationPrice')
      ?.updateValueAndValidity({ emitEvent: false });
    this.documentDetailsArray().at(0).get('stampDutyValue')?.clearValidators();
    this.documentDetailsArray()
      .at(0)
      .get('stampDutyValue')
      ?.updateValueAndValidity({ emitEvent: false });
  }
  getStateDenominationForProcessOptions(state_code: string) {
    if (this.isOperationalNeslContract) {
      this.processOptions = [{ label: 'On the Fly', value: 'ON_THE_FLY' }];
      const needsProcessChange = this.documentDetailsArray().controls.some(
        (group: FormGroup) => group.getRawValue().process_type !== 'ON_THE_FLY',
      );
      this.documentDetailsArray().controls.forEach((group: FormGroup) => {
        group.patchValue({ process_type: 'ON_THE_FLY' }, { emitEvent: false });
      });
      this.process_type = 'ON_THE_FLY';
      if (needsProcessChange) {
        this.onProcessChange({ value: 'ON_THE_FLY' });
      }
      return;
    }
    let queryParams: any = {
      state_code: state_code,
    };

    this.estampService.getStateDenomination(queryParams).subscribe((resp) => {
      if (resp.status && resp['content'] && resp['content'].length > 0) {
        const stateInfo = resp['content'][0];
        const options = [];

        if (stateInfo.pre_estamp === true || stateInfo.traditional === true) {
          options.push({ label: 'Inventory', value: 'PRE_PROCUREMENT' });
        }
        if (stateInfo.estamp === true) {
          options.push({ label: 'On the Fly', value: 'ON_THE_FLY' });
        }
        if (stateInfo.esbtr === true) {
          options.push({ label: 'ESBTR', value: 'ESBTR' });
        }

        this.processOptions = options;

        // Only auto-bind process_type from defaults when in Default mode
        if (
          this.isDefault &&
          this.setEstampDefaultDetails &&
          this.setEstampDefaultDetails.length > 0
        ) {
          const defaultProcessType = this.setEstampDefaultDetails.find(
            (item) => item.stateId === this.state_id,
          )?.process_type;

          if (defaultProcessType) {
            const isValidOption = options.some(
              (opt) => opt.value === defaultProcessType,
            );
            if (isValidOption) {
              this.documentDetailsArray().controls.forEach(
                (group: FormGroup) => {
                  group.patchValue({ process_type: defaultProcessType });
                },
              );
              this.process_type = defaultProcessType;
              this.onProcessChange({ value: defaultProcessType });
            }
          }
        }
      }
    });
  }
  //------------------------------------------------------------------------------------------------------//
  generateReferenceId() {
    this.estampService.getOrValidateReferenceId().subscribe(
      (res: any) => {
        if (res.status === 200) {
          setTimeout(() => {
            this.estampDetails.controls['referenceNumber'].setValue(
              res.content.reference_id,
            );
          }, 0);
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      },
    );
  }

  getRefIdConsent(draftData?: any) {
    const refIdConsent = this.storageService.getRefIdConsent() || null;

    if (refIdConsent === true) {
      // Manual Entry toggle ON: user types their own reference number — field blank, editable
      this.enableRefIdField = true;
      this.estampDetails.controls['referenceNumber'].setValue('');
    } else {
      // Manual Entry toggle OFF: system auto-generates from API
      this.enableRefIdField = false;
      if (draftData && draftData.order && draftData.order.referance_id) {
        this.estampDetails.controls['referenceNumber'].setValue(
          draftData.order.referance_id,
        );
        return;
      }

      this.generateReferenceId();
    }
  }

  isAnyDocumentToBeStampedSelected(): boolean {
    if (this.service !== 'MULTIPLE-STAMP') return true;
    let value = this.documentDetailsArray().controls.some(
      (ctrl) => ctrl.get('documentToBeEstamp')?.value === true,
    );
    return value;
  }

  openValidatePopup() {
    if (!this.isAnyDocumentToBeStampedSelected()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail:
          'At least one document needs to be e-stamped to proceed further.',
      });
      return;
    }

    // For MULTIPLE-STAMP service, validate only documents that are to be stamped
    let hasValidationErrors = false;

    if (this.service === 'MULTIPLE-STAMP') {
      // Check only documents that have documentToBeEstamp = true
      this.documentDetailsArray().controls.forEach((control, index) => {
        const shouldBeStamped = control.get('documentToBeEstamp')?.value;
        if (shouldBeStamped && control.invalid) {
          hasValidationErrors = true;
        }
      });
    } else {
      // Original validation for non-MULTIPLE-STAMP services
      hasValidationErrors = !this.estampDetails.valid && this.isEstamped;
    }

    if (hasValidationErrors || this.isAnyRequiredFileMissing()) {
      console.warn('Validation failed, skipping popup.');
      return;
    }

    this.submitted = true;
    const hasInvalidBranch = this.documentDetailsArray().controls.some(
      (ctrl) => {
        const shouldBeStamped = ctrl.get('documentToBeEstamp')?.value;
        // Only check branch validity for documents that should be stamped
        return (
          this.isEstamped &&
          shouldBeStamped &&
          (ctrl.get('selectBranch')?.invalid ||
            !ctrl.get('selectBranch')?.value)
        );
      },
    );

    if (hasInvalidBranch) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please select a branch for all E-stamps before proceeding.',
      });
      return;
    }

    for (const [key, value] of Object.entries(
      this.eStampAdditionalForm.value,
    )) {
      if (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        this.messageService.add({
          severity: 'warn',
          detail: `${key} can't be null`,
        });
        return;
      }
    }

    this.documentDetailsArray().value.forEach((element, index) => {
      // Only validate documents that should be stamped
      if (!element.documentToBeEstamp) return;

      ((element.stampDutyValue = Array.isArray(element.stampDutyValue)
        ? element.stampDutyValue[0]
        : element.stampDutyValue),
        (this.isConsiderationPriceValid[index] = true));
      this.isStampValueValid[index] = true;

      if (element.considerationPrice === null && this.isEstamped) {
        this.messageService.add({
          severity: 'warn',
          detail: 'Consideration Value cannot be Empty',
        });
        this.isConsiderationPriceValid[index] = false;
      }
      if (
        (element.stampDutyValue === null ||
          element.stampDutyValue === '' ||
          element.stampDutyValue === 0) &&
        this.isEstamped &&
        element.documentToBeEstamp
      ) {
        this.messageService.add({
          severity: 'warn',
          detail: 'Stamp Duty Value cannot be Empty or 0',
        });
        this.isStampValueValid[index] = false;
      }
    });

    let nextStep = true;

    // Only check validation for documents that should be stamped
    this.documentDetailsArray().value.forEach((element, index) => {
      if (!element.documentToBeEstamp) return;

      if (
        !this.isConsiderationPriceValid[index] ||
        !this.isStampValueValid[index]
      ) {
        nextStep = false;
      }
    });

    if (!nextStep) {
      // If considerationPrice is not valid, stop further execution
      return;
    }

    if (!this.isEstamped && !this.pathId) this.goToEsign();

    // Final validation check for documents that should be stamped
    let finalValidationPassed = true;
    if (this.service === 'MULTIPLE-STAMP') {
      this.documentDetailsArray().controls.forEach((control) => {
        const shouldBeStamped = control.get('documentToBeEstamp')?.value;
        if (shouldBeStamped && control.invalid) {
          finalValidationPassed = false;
        }
      });
    } else {
      finalValidationPassed = this.estampDetails.valid;
    }

    if (!finalValidationPassed) return;
    else {
      if (this.isEstamped) {
        this.estampDataForValidation =
          this.documentDetailsArray().controls.filter(
            (element) => element.value.documentToBeEstamp === true,
          );

        this.estampDataForValidation.forEach((element) => {
          const articleId = element.get('articleNumber')?.value;
       
          const selectedArticle = this.articles
            .flat()
            .find(
              (article) =>
                articleId !== null &&
                articleId !== undefined &&
                String(article.id) === String(articleId),
            );

          element.value['article_code'] =
            selectedArticle?.article_code || selectedArticle?.articleDisplay || '';
        });
        this.validateDataModalPopup.nativeElement.click();
      }
    }
  }

  validateReferenceId() {
    let enteredReferenceId = this.estampDetails.value.referenceNumber;

    if (this.service === 'MULTIPLE-STAMP' && (!enteredReferenceId || enteredReferenceId.trim() === '')) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation',
        detail: 'Please enter a Reference Number before proceeding.',
      });
      return;
    }

    this.estampService.getOrValidateReferenceId(enteredReferenceId).subscribe(
      (res: any) => {
        if (res.status === 200) {
          if (this.pathId) {
            this.placeOrder();
          } else {
            this.goToEsign();
          }
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      },
    );
  }

  closeDataConfirmPopup() {
    this.closeDataConfirmPopupBtn.nativeElement.click();
    this.isDatavalidated = false;
  }

  dataConformation() {
    this.isDatavalidated = true;
    this.closeDataConfirmPopupBtn.nativeElement.click();
    this.validateReferenceId();
  }

  tobeDefault(value: boolean) {
    const previousMode = this.custom ? 'custom' : 'default';
    const nextMode = value ? 'default' : 'custom';
    const firstDetails = this.documentDetailsArray().at(0);
    if (firstDetails) {
      this.panValuesByMode[previousMode] = {
        first_party_pan: firstDetails.get('first_party_pan')?.value || '',
        second_party_pan: firstDetails.get('second_party_pan')?.value || '',
      };
    }

    this.stampAmountInWords[0] = null;
    this.estampData = undefined;

    this.isDefault = value;
    this.stateWasManuallyChanged = false;
    if (this.isDefault) {
      this.readOnlyDefault[0] = !this.estamp_field_editable;
    } else {
      this.readOnlyDefault[0] = value;
    }
    if (this.isDefault === true) {
      this.default = true;
      this.custom = false;

      this.stateSelected = this.storageService.getState() || null;
      this.selectedBranch = this.storageService.getBranch() || null;

      const formArray = this.documentDetailsArray();
      for (let i = formArray.length - 1; i > 0; i--) {
        formArray.removeAt(i);
      }

      // Fetch branch data for the selected state/account before patching the form
      this.getBranchDetails(this.stateSelected.id).subscribe(() => {
        if (this.custom) return;
        this.documentDetailsArray()
          .at(0)
          .patchValue({
            firstPartyName: '',
            secondPartyName: '',
            stampDutyPaidBy: '',
            stampDutyValue: null,
            considerationPrice: '',
            purposeOfStampDuty: '',
            selectedState: this.stateSelected || null,
            selectBranch: this.selectedBranch || null,
            articleNumber: '',
            process_type: this.process_type,
            execution_date: this.today,
          });
      });

      this.getDefaultFieldData(this.account_id);
    } else {
      this.default = false;
      this.custom = true;

      this.estamp_default_fields = undefined;
      this.setEstampDefaultDetails = [];

      this.readOnlyFields = false;
      this.readOnlyDefault = this.readOnlyDefault.map(() => false);
      this.readOnlyStampAmt = false;

      const formArray = this.documentDetailsArray();
      for (let i = formArray.length - 1; i > 0; i--) {
        formArray.removeAt(i);
      }

      this.documentDetailsArray().at(0).patchValue({
        firstPartyName: '',
        secondPartyName: '',
        stampDutyPaidBy: '',
        stampDutyValue: null,
        considerationPrice: '',
        purposeOfStampDuty: '',
        selectedState: null,
        selectBranch: null,
        articleNumber: '',
        process_type: null,
        execution_date: this.today,
      });

      this.stateSelected = null;
      this.selectedBranch = null;

      this.stampAmountInWords[0] = null;
      this.considerationPriceInWords[0] = 0;
      this.denominationData[0] = [];

      this.documentDetailsArray()
        .at(0)
        .get('considerationPrice')
        ?.clearValidators();
      this.documentDetailsArray()
        .at(0)
        .get('considerationPrice')
        ?.updateValueAndValidity({ emitEvent: false });

      this.documentDetailsArray()
        .at(0)
        .get('process_type')
        ?.enable({ emitEvent: false });

      this.cdr.detectChanges();
    }

    this.documentDetailsArray().at(0)?.patchValue(
      this.panValuesByMode[nextMode],
      { emitEvent: false },
    );
  }

  handlePasteEvent(event: ClipboardEvent) {
    const paste = event.clipboardData.getData('text');
    // Regular expression to match only alphanumeric characters and spaces
    const regex = /^[a-zA-Z0-9 ]+$/;
    if (!regex.test(paste)) {
      event.preventDefault();
    }
  }

  convertExponentialToNumberString(value: number | string): string {
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (!isNaN(numericValue)) {
      return numericValue.toString();
    }

    return 'Invalid input';
  }

  getStateDenomination(
    state_code,
    article_id,
    consideration_amount,
    index,
    account_id,
  ) {
    const currentProcessType = this.documentDetailsArray()
      .at(index)
      .getRawValue().process_type;
 const parsedConsideration = consideration_amount !== null && consideration_amount !== undefined && consideration_amount !== ''
      ? Number(consideration_amount)
      : null;
    const useNeslCalculation =
      this.isNeslMetadataContract && currentProcessType === 'ON_THE_FLY';
    const selectedContractType = String(
      this.isDocumentType || this.storageService.getContractNumber() || '',
    );
    let queryParams: any = {
      state_code: state_code,
      article_id: article_id,
      consideration_amount: parsedConsideration ?? '',
      sync: true,
      account_id: account_id,
      ...(useNeslCalculation && {
        contract_type: selectedContractType,
        provider_code: '001',
      }),
    };

    if (article_id) {
      if (
        parsedConsideration === null ||
        (!useNeslCalculation && parsedConsideration <= 0)
      ) {
        return;
      }
      if (!this.denominationData[index]) {
        this.denominationData[index] = [];
      }

      this.estampService.getStateDenomination(queryParams).subscribe((resp) => {
        if (resp.status) {
          let denominationData =
            resp['content'][0]['denomination'][0] ||
            resp['content'][0]['denomination'];

          const formGroup = this.documentDetailsArray().at(index);
          const stampDutyCtrl = formGroup.get('stampDutyValue');
          const isInventoryOrEsbtr =
            currentProcessType === 'PRE_PROCUREMENT' ||
            currentProcessType === 'ESBTR';

          if (Array.isArray(denominationData)) {
            const uniqueAmounts = Array.from(new Set(denominationData));
            this.denominationData[index] = uniqueAmounts.map((value) => ({
              amount: value,
            }));
            this.readOnlyStampAmt = false;

            if (denominationData.length > 0) {
              const minDenomination = Math.min(...denominationData);
              this.minStampValue[index] = isInventoryOrEsbtr
                ? null
                : minDenomination;
              // Inventory/ESBTR: any value > 0; ON_THE_FLY: enforce API minimum
              stampDutyCtrl.setValidators(
                isInventoryOrEsbtr
                  ? [Validators.required, this.notOnlyZeroValidator]
                  : [Validators.required, Validators.min(minDenomination)],
              );
              stampDutyCtrl.clearAsyncValidators();
              stampDutyCtrl.updateValueAndValidity({ emitEvent: false });
            }
          } else {
            const value = { amount: denominationData };
            this.denominationData[index] = [value];
            this.minStampValue[index] = isInventoryOrEsbtr
              ? null
              : denominationData;
            // For Inventory/ESBTR keep fields editable; only lock for ON_THE_FLY
            this.readOnlyStampAmt = isInventoryOrEsbtr ? false : true;

            if (!this.isDraftLoading) {
              stampDutyCtrl.setValue(denominationData);
              this.stampAmountInWords[index] = denominationData;
            }

            // Inventory/ESBTR: any value > 0; ON_THE_FLY: enforce API minimum
            stampDutyCtrl.setValidators(
              isInventoryOrEsbtr
                ? [Validators.required, this.notOnlyZeroValidator]
                : [Validators.min(denominationData)],
            );
            stampDutyCtrl.clearAsyncValidators();
            stampDutyCtrl.updateValueAndValidity({ emitEvent: false });
          }

          this.cdr.detectChanges();
          const considerationPriceControl = formGroup.get('considerationPrice');
          if (
            !this.isDraftLoading &&
            considerationPriceControl &&
            considerationPriceControl.invalid &&
            this.selectedArticleAmount[index] &&
            (this.selectedArticleAmount[index].fix_stamp_duty === undefined ||
              !isInventoryOrEsbtr)
          ) {
            stampDutyCtrl.setValue('');
            this.stampAmountInWords[index] = null;
          }
        }
      });
    }
  }

  convertToNumber(event: any, index: number): void {
    const inputValue = event.target.value;

    const numericValue = parseFloat(inputValue);

    if (inputValue !== '') {
      this.stampAmountInWords[index] = numericValue;
    } else {
      this.stampAmountInWords[index] = null;
    }

    // Check if numericValue is a valid number and not NaN
    if (!isNaN(numericValue)) {
      // Set the numeric value to the form control for the specified index
      this.documentDetailsArray()
        .at(index)
        .get('stampDutyValue')
        ?.setValue(numericValue);
    } else {
      console.log('Invalid input. Please enter a valid number.');
    }
  }

  viewBulk() {
    if (this.service === 'MULTIPLE-STAMP') {
      this.cancelBulkOption(); // Auto trigger the "Continue Anyway" logic
    } else {
      this.modalService
        .open(this.bulkOptionModalPopup, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          },
        );
    }
  }

  onSelectStampAmount(evt, index) {
    this.stampAmountInWords[index] = evt.value;
    this.showPanCard[index] = false;
    const control = this.documentDetailsArray().at(index).get('stampDutyValue');

    // Clear existing validators
    control.clearValidators();

    const currentProcessType = this.documentDetailsArray()
      .at(index)
      .getRawValue().process_type;
    const isInventoryOrEsbtr =
      currentProcessType === 'PRE_PROCUREMENT' ||
      currentProcessType === 'ESBTR';
    const minStampValue = this.minStampValue[index];

    if (isInventoryOrEsbtr) {
      // Inventory/ESBTR: any value > 0 allowed
      control.setValidators([Validators.required, this.notOnlyZeroValidator]);
    } else if (minStampValue !== null) {
      control.setValidators([Validators.min(minStampValue)]);
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  //-------------------------------------------payment data ------------------------------------//

  onSelectedPlace(event) {
    this.storageService.setPlace(event.value);
  }

  toSignerToPay(value: boolean) {
    this.showPaymentDetails = value;
    this.estampDetails.controls.paymentbySigner.setValue(
      this.showPaymentDetails,
    );
    this.storageService.getSignerValue.next(value);
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   if (this.stateSelected) {
    //     this.setStateData(0);
    //   }
    // }, 700);
  }

  generateFileUniqueId() {
    return 'doc-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
  }

  async onFileSelected(event: Event, i: number): Promise<void> {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Validate if the file is a PDF
      const isPdf =
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf');
      if (!isPdf) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid File',
          detail: 'Please add a valid pdf file',
        });
        input.value = '';
        return;
      }

      // 15MB size check
      const maxFileSize = 15 * 1024 * 1024;
      if (file.size > maxFileSize) {
        this.messageService.add({
          severity: 'error',
          summary: 'File Too Large',
          detail: 'File exceeds 15MB limit',
        });
        input.value = '';
        return;
      }

      // Stage file and open preview modal immediately in upload mode
      this.stagedUploadFile = file;
      this.newlyUploadedEstampIndex = i;
      this.activePreviewEstampIndex = i;
      this.previewFile = file;
      this.previewPdfSrc = null;
      this.previewFileName = file.name;
      this.previewModalMode = 'upload';
      this.previewModalVisible = true;
      input.value = '';
      this.cdr.detectChanges();
    }
  }

  isAnyRequiredFileMissing(): boolean {
    return this.getMissingFileIndex() !== -1;
  }

  getMissingFileIndex(): number {
    if (this.service !== 'MULTIPLE-STAMP') return -1;

    return this.documentDetailsArray().controls.findIndex((control, index) => {
      const isUseSame = control.get('isUseSamePreviousFile')?.value;
      return !isUseSame && !this.fileSelectedMap[index];
    });
  }

  useSamePreviousFile(usePrevious: boolean, i: number): void {
    if (i <= 0) {
      return;
    }

    const prev = this.documentDetailsArray().at(i - 1);
    const curr = this.documentDetailsArray().at(i);

    if (usePrevious) {
      const prevBase64 = prev.get('file')?.value;
      const prevUniqueId = prev.get('fileUniqueId')?.value;
      const fileName = prev.get('fileName')?.value;

      curr.get('file')?.setValue(prevBase64);
      curr.get('fileUniqueId')?.setValue(prevUniqueId);
      curr.get('fileName')?.setValue(fileName);
      if (this.uploadedFileObjects[i - 1]) {
        this.uploadedFileObjects[i] = this.uploadedFileObjects[i - 1];
      }
    } else {
      curr.get('file')?.reset();
      curr.get('fileUniqueId')?.reset();
      curr.get('fileName')?.reset();
      delete this.uploadedFileObjects[i];
      // File data was cleared — mark it as not selected so validation catches it
      this.fileSelectedMap[i] = false;
    }

    curr.get('isUseSamePreviousFile')?.setValue(usePrevious);
  }

  onDocumentToBeEstamp(i: number): void {
    var formValidators = {
      firstPartyName: [
        Validators.required,
        noSpacesValidator(),
        Validators.maxLength(50),
        this.notOnlyNumbersValidator(),
        this.noLeadingSpacesValidator(),
      ],
      secondPartyName: [
        Validators.required,
        noSpacesValidator(),
        Validators.maxLength(50),
        this.notOnlyNumbersValidator(),
        this.noLeadingSpacesValidator(),
      ],
      stampDutyPaidBy: [Validators.required],
      stampDutyValue: [Validators.required, this.notOnlyZeroValidator],
      purposeOfStampDuty: [
        Validators.required,
        this.noLeadingSpacesValidator(),
      ],
      NoOfCopies: [Validators.required],
      articleNumber: [Validators.required],
      considerationPrice: [Validators.required],
      execution_date: [Validators.required],
      selectedState: [Validators.required],
      selectBranch: [Validators.required],
      process_type: [Validators.required],
    };

    var documentToBeEstamp = this.documentDetailsArray()
      .at(i)
      .get('documentToBeEstamp')?.value;
    const formGroup = this.documentDetailsArray().at(i) as FormGroup;

    // Handle validators for current form
    for (const field in formValidators) {
      const control = formGroup.get(field);
      if (control) {
        control.clearValidators();
        control.setValidators(
          !documentToBeEstamp
            ? []
            : (formValidators[
                field as keyof typeof formValidators
              ] as ValidatorFn[]),
        );
        control.updateValueAndValidity({ emitEvent: false });
      }
    }

    const curr = this.documentDetailsArray().at(i);

    if (!documentToBeEstamp) {
      // Keep isUseSamePreviousFile enabled so the user can still use a previous
      // file — the document upload validation must remain even when the stamp
      // option is deselected (file is always required in MULTIPLE-STAMP flow).
      curr.get('isUseSamePreviousFile')?.enable();

      // Handle default data cascading for multi-stamp
      if (this.service === 'MULTIPLE-STAMP' && this.isDefault) {
        this.cascadeDefaultDataAfterUnchecking(i);
      }
    } else {
      curr.get('isUseSamePreviousFile')?.enable();

      // Handle default data restoration for multi-stamp
      if (this.service === 'MULTIPLE-STAMP' && this.isDefault) {
        this.restoreDefaultDataAfterChecking(i);
      }
    }
  }

  isDocumentToBeEstamp(documentDetailsIndex: number): boolean {
    if (this.service !== 'MULTIPLE-STAMP') {
      return true; // Show fields for SINGLE-STAMP or other services
    }

    // For MULTIPLE-STAMP, show fields only if the checkbox is selected
    return (
      this.documentDetailsArray()
        .at(documentDetailsIndex)
        .get('documentToBeEstamp')?.value === true
    );
  }

  paymentMethod(value: string) {
    const isGateway =
      value === this.paymentbyRazorpay || value === 'HDFC_GATEWAY';
    if (isGateway) {
      this.showPaymentDetails = true;
      this.validationForRazorypay = true;
      // this.storageService.setSelectedProvider(value);
      this.storageService.setSelectedProvider(
        value === 'HDFC_GATEWAY' ? 'HDFC_GATEWAY' : 'RAZORPAY_GATEWAY',
      );
    } else {
      this.showPaymentDetails = false;
      this.validationForRazorypay = false;
    }
    if (value === this.payLater) {
      this.estampDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    } else {
      this.estampDetails.controls.paymentbySigner.setValue(true);
      this.storageService.getSignerValue.next(true);
    }
    this.estampDetails.controls.paymentMethod.setValue(value);
    this.updateRazorypayFieldValidation();
  }
  previewEstampDocument(index: number): void {
    const control = this.documentDetailsArray().at(index);
    if (!control) return;

    this.newlyUploadedEstampIndex = -1;
    this.previewModalMode = 'preview';

    const fileObj = this.uploadedFileObjects[index];
    const fileData = control.get('file')?.value;
    const fileName = control.get('fileName')?.value || 'Document.pdf';

    this.activePreviewEstampIndex = index;
    this.previewFileName = fileName;

    if (fileObj instanceof File) {
      this.previewFile = fileObj;
      this.previewPdfSrc = null;
    } else if (fileData instanceof File) {
      this.previewFile = fileData;
      this.previewPdfSrc = null;
    } else if (fileData) {
      this.previewFile = null;
      this.previewPdfSrc = fileData;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Preview Unavailable',
        detail: 'No document content available to preview.',
      });
      return;
    }

    this.previewModalVisible = true;
    this.cdr.detectChanges();
  }

  previewNewlyUploadedEstamp(index: number): void {
    const control = this.documentDetailsArray().at(index);
    if (!control) return;

    this.newlyUploadedEstampIndex = index;
    this.activePreviewEstampIndex = index;
    this.previewFileName = control.get('fileName')?.value || 'Document.pdf';

    const fileObj = this.uploadedFileObjects[index];
    const fileData = control.get('file')?.value;

    if (fileObj instanceof File) {
      this.previewFile = fileObj;
      this.previewPdfSrc = null;
    } else if (fileData instanceof File) {
      this.previewFile = fileData;
      this.previewPdfSrc = null;
    } else if (fileData) {
      this.previewFile = null;
      this.previewPdfSrc = fileData;
    }

    this.previewModalMode = 'upload';
    this.previewModalVisible = true;
    this.cdr.detectChanges();
  }

  async onEstampUploadConfirmed(event: {
    file: File;
    base64?: string;
    arrayBuffer?: ArrayBuffer;
  }): Promise<void> {
    const idx =
      this.newlyUploadedEstampIndex >= 0
        ? this.newlyUploadedEstampIndex
        : this.activePreviewEstampIndex;

    if (idx >= 0 && idx < this.documentDetailsArray().length) {
      try {
        const targetFile = event.file || this.stagedUploadFile;
        let base64Data = event.base64;
        if (!base64Data && targetFile) {
          base64Data = await this.pdfResizeService.convertFileToBase64(targetFile);
        }
        if (base64Data && !base64Data.startsWith('data:')) {
          base64Data = `data:application/pdf;base64,${base64Data}`;
        }

        const control = this.documentDetailsArray().at(idx);
        control.get('file')?.setValue(base64Data);
        control.get('fileUniqueId')?.setValue(this.generateFileUniqueId());
        control.get('fileName')?.setValue(targetFile?.name || 'Document.pdf');
        this.fileSelectedMap[idx] = true;
        if (targetFile) {
          this.uploadedFileObjects[idx] = targetFile;
        }

        // Update downstream documents if they share the previous file
        const totalCount = this.documentDetailsArray().length;
        for (let j = idx + 1; j < totalCount; j++) {
          const nextCtrl = this.documentDetailsArray().at(j);
          if (nextCtrl.get('isUseSamePreviousFile')?.value) {
            nextCtrl.get('file')?.setValue(base64Data);
            nextCtrl.get('fileName')?.setValue(targetFile?.name || 'Document.pdf');
            if (targetFile) {
              this.uploadedFileObjects[j] = targetFile;
            }
          } else {
            break;
          }
        }

        this.messageService.add({
          severity: 'success',
          summary: 'File Uploaded',
          detail: `${targetFile?.name || 'Document'} uploaded successfully`,
          life: 3000,
        });
      } catch (error) {
        console.error('Error in onEstampUploadConfirmed:', error);
      }
    }

    this.stagedUploadFile = null;
    this.newlyUploadedEstampIndex = -1;
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onEstampUploadCancelled(): void {
    if (this.previewModalMode === 'upload') {
      this.stagedUploadFile = null;
      this.newlyUploadedEstampIndex = -1;
    }
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  async onEstampPreviewSaved(event: {
    file: File;
    base64?: string;
    arrayBuffer?: ArrayBuffer;
  }): Promise<void> {
    if (this.activePreviewEstampIndex < 0) return;

    const control = this.documentDetailsArray().at(
      this.activePreviewEstampIndex
    );
    if (!control) return;

    let base64Data = event.base64;
    if (!base64Data && event.file) {
      base64Data = await this.pdfResizeService.convertFileToBase64(event.file);
    }

    if (base64Data) {
      control.get('file')?.setValue(base64Data);
      control.get('fileName')?.setValue(event.file.name);
      this.uploadedFileObjects[this.activePreviewEstampIndex] = event.file;
      this.fileSelectedMap[this.activePreviewEstampIndex] = true;

      // Update downstream documents if they share the previous file
      const totalCount = this.documentDetailsArray().length;
      for (let i = this.activePreviewEstampIndex + 1; i < totalCount; i++) {
        const nextCtrl = this.documentDetailsArray().at(i);
        if (nextCtrl.get('isUseSamePreviousFile')?.value) {
          nextCtrl.get('file')?.setValue(base64Data);
          nextCtrl.get('fileName')?.setValue(event.file.name);
          this.uploadedFileObjects[i] = event.file;
        } else {
          break;
        }
      }

      this.messageService.add({
        severity: 'success',
        summary: 'Updated',
        detail: 'Document changes saved successfully.',
      });
    }
    this.cdr.detectChanges();
  }

  // New methods for modal functionality
  openFileModal(documentIndex: number): void {
    this.currentDocumentIndex = documentIndex;
    this.selectedFile = null;
    this.fileSizeError = false;
    this.isDragOver = false;
    this.showFileModal = true;
  }

  async onModalFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Basic PDF check first
      const isPdf =
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf');

      if (!isPdf) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid File Type',
          detail: `Only PDF files are allowed. Rejected file: ${file.name}`,
        });
        input.value = '';
        return;
      }

      // Process the file with full validation
      const isValid = await this.processSelectedFile(file);
      input.value = '';
      if (isValid) {
        const targetDocIndex = this.currentDocumentIndex;
        this.showFileModal = false;
        this.newlyUploadedEstampIndex = targetDocIndex;
        this.activePreviewEstampIndex = targetDocIndex;
        this.stagedUploadFile = file;
        this.previewFile = file;
        this.previewPdfSrc = null;
        this.previewFileName = file.name;
        this.previewModalMode = 'upload';
        this.previewModalVisible = true;
        this.cdr.detectChanges();
        return;
      }
      input.value = ''; // Clear input for next selection
    }
  }

  cancelFileSelection(): void {
    this.showFileModal = false;
    this.selectedFile = null;
    this.selectedFileBase64 = '';
    this.currentDocumentIndex = -1;
    this.fileSizeError = false;
    this.isDragOver = false;
  }

  // File Processing Methods
  private async processSelectedFile(file: File): Promise<boolean> {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    // 1. File size validation
    if (file.size > maxFileSize) {
      this.fileSizeError = true;
      this.selectedFile = null;
      this.messageService.add({
        severity: 'error',
        summary: 'File Too Large',
        detail: `File exceeds 15MB limit: ${file.name} (${(
          file.size /
          1024 /
          1024
        ).toFixed(2)}MB). Please upload a smaller PDF so it can be processed within the gateway's size limits.`,
        life: 5000,
      });
      return false;
    }

    if (file.size < this.MIN_PDF_SIZE_BYTES) {
      this.fileSizeError = false;
      this.selectedFile = null;
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File',
        detail: 'File is too small to be a valid PDF',
        life: 5000,
      });
      return false;
    }

    // 2. File type validation
    const isPdf =
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf');

    if (!isPdf) {
      this.fileSizeError = false;
      this.selectedFile = null;
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File Type',
        detail: `Only PDF files are allowed. Rejected file: ${file.name}`,
        life: 5000,
      });
      return false;
    }

    // 3. SECURITY VALIDATION using PdfSecurityService
    try {
      const validationResult =
        await this.pdfSecurityService.validateAndSanitizePDF(file);

      // Check for e-signed PDFs FIRST
      if (validationResult.isESigned === true) {
        this.fileSizeError = false;
        this.selectedFile = null;
        this.messageService.add({
          severity: 'warn',
          summary: 'Signed Document Detected',
          detail: 'Document is already signed',
          life: 5000,
        });
        return false;
      }

      // Check for other security threats
      if (!validationResult.isValid) {
        this.fileSizeError = false;
        this.selectedFile = null;
        this.messageService.add({
          severity: 'error',
          summary: 'Security Validation Failed',
          detail: `${file.name}: ${validationResult.reason}`,
          life: 7000,
        });
        return false;
      }

      // All validations passed
      this.fileSizeError = false;
      this.selectedFile = file;

      this.messageService.add({
        severity: 'success',
        summary: 'File Selected',
        detail: `${file.name} is ready to upload`,
        life: 3000,
      });

      return true;
    } catch (error) {
      console.error('Error processing file:', error);
      this.fileSizeError = false;
      this.selectedFile = null;
      this.messageService.add({
        severity: 'error',
        summary: 'Processing Error',
        detail: 'Error processing PDF file. Please try again.',
        life: 5000,
      });
      return false;
    }
  }

  async uploadFile(): Promise<void> {
    if (!this.selectedFile || this.currentDocumentIndex === -1) {
      return;
    }

    try {
      let base64Data: string;

      if (this.selectedFileBase64) {
        base64Data = this.selectedFileBase64;
      } else {
        base64Data = await this.pdfResizeService.convertFileToBase64(
          this.selectedFile,
        );
      }

      if (
        !this.pdfValidationService.validateBase64String(
          base64Data,
          this.selectedFile.name,
        )
      ) {
        return;
      }

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('file')
        ?.setValue(base64Data);

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileUniqueId')
        ?.setValue(this.generateFileUniqueId());

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileName')
        ?.setValue(this.selectedFile.name);

      this.fileSelectedMap[this.currentDocumentIndex] = true;
      if (this.selectedFile) {
        this.uploadedFileObjects[this.currentDocumentIndex] = this.selectedFile;
      }

      // Success message
      this.messageService.add({
        severity: 'success',
        summary: 'File Uploaded',
        detail: `${this.selectedFile.name} uploaded successfully`,
        life: 3000,
      });

      const uploadedDocIdx = this.currentDocumentIndex;
      this.showFileModal = false;
      this.selectedFile = null;
      this.selectedFileBase64 = '';
      this.currentDocumentIndex = -1;
      this.fileSizeError = false;
      this.isDragOver = false;

      setTimeout(() => {
        this.previewNewlyUploadedEstamp(uploadedDocIdx);
        this.cdr.detectChanges();
      }, 400);
    } catch (error) {
      console.error('Error converting file to Base64:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Upload Failed',
        detail: 'Error converting file. Please try again.',
      });
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getCurrentDocumentIndex(): number {
    return this.currentDocumentIndex !== -1 ? this.currentDocumentIndex : 0;
  }

  // Drag and drop methods
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const fileArray: File[] = Array.from(files);

    // Filter only PDF files
    const pdfFiles = fileArray.filter(
      (file) =>
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf'),
    );

    const nonPdfFiles = fileArray.filter(
      (file) =>
        file.type !== 'application/pdf' &&
        !file.name.toLowerCase().endsWith('.pdf'),
    );

    if (nonPdfFiles.length > 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File Type',
        detail: `Only PDF files are allowed. Rejected: ${nonPdfFiles
          .map((f) => f.name)
          .join(', ')}`,
      });
    }

    // Process only the first PDF file
    if (pdfFiles.length > 0) {
      const isValid = await this.processSelectedFile(pdfFiles[0]);
      if (isValid) {
        const targetDocIndex = this.currentDocumentIndex;
        this.showFileModal = false;
        this.newlyUploadedEstampIndex = targetDocIndex;
        this.activePreviewEstampIndex = targetDocIndex;
        this.stagedUploadFile = pdfFiles[0];
        this.previewFile = pdfFiles[0];
        this.previewPdfSrc = null;
        this.previewFileName = pdfFiles[0].name;
        this.previewModalMode = 'upload';
        this.previewModalVisible = true;
        this.cdr.detectChanges();
      }
    }
  }

  // Google Drive Methods
  openGoogleDrive(documentIndex: number = -1): void {
    this.currentDocumentIndex = documentIndex;
    this.showGoogleDriveModal = true;
  }

  async onGoogleDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }): Promise<void> {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    if (event.file.size > maxFileSize) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} exceeds 15MB limit`,
      });
      this.showGoogleDriveModal = false;
      return;
    }

    const isAlreadySelected = this.documentDetailsArray().controls.some(
      (control) =>
        control.get('fileName')?.value === event.fileName &&
        control.get('file')?.value,
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      this.showGoogleDriveModal = false;
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      this.showGoogleDriveModal = false;
      return;
    }

    if (this.currentDocumentIndex === -1) {
      this.showGoogleDriveModal = false;
      return;
    }

    try {
      const base64Data = event.base64;

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('file')
        ?.setValue(base64Data);

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileUniqueId')
        ?.setValue(this.generateFileUniqueId());

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileName')
        ?.setValue(event.fileName);

      this.fileSelectedMap[this.currentDocumentIndex] = true;
      if (event.file) {
        this.uploadedFileObjects[this.currentDocumentIndex] = event.file;
      }

      const gDriveDocIdx = this.currentDocumentIndex;
      this.showGoogleDriveModal = false;
      this.showFileModal = false;
      this.selectedFile = null;
      this.selectedFileBase64 = '';
      this.currentDocumentIndex = -1;
      this.fileSizeError = false;
      this.isDragOver = false;

      setTimeout(() => {
        this.previewNewlyUploadedEstamp(gDriveDocIdx);
        this.cdr.detectChanges();
      }, 400);

      this.messageService.add({
        severity: 'success',
        detail: `File "${event.fileName}" uploaded successfully from Google Drive`,
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Error processing file from Google Drive',
      });
    }
  }

  onGoogleDriveModalClosed(): void {
    this.showGoogleDriveModal = false;
    this.selectedFile = null;
    this.currentDocumentIndex = -1;
  }

  // Link Upload Methods
  openLink(documentIndex: number = -1): void {
    this.currentDocumentIndex = documentIndex;
    this.showLinkModal = true;
  }

  async onLinkFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }): Promise<void> {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    if (event.file.size > maxFileSize) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} exceeds 15MB limit`,
      });
      this.showLinkModal = false;
      return;
    }

    const isAlreadySelected = this.documentDetailsArray().controls.some(
      (control) =>
        control.get('fileName')?.value === event.fileName &&
        control.get('file')?.value,
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      this.showLinkModal = false;
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      this.showLinkModal = false;
      return;
    }

    if (this.currentDocumentIndex === -1) {
      this.showLinkModal = false;
      return;
    }

    try {
      const base64Data = event.base64;

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('file')
        ?.setValue(base64Data);

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileUniqueId')
        ?.setValue(this.generateFileUniqueId());

      this.documentDetailsArray()
        .at(this.currentDocumentIndex)
        .get('fileName')
        ?.setValue(event.fileName);

      this.fileSelectedMap[this.currentDocumentIndex] = true;

      this.showLinkModal = false;
      this.showFileModal = false;
      this.selectedFile = null;
      this.selectedFileBase64 = '';
      this.currentDocumentIndex = -1;
      this.fileSizeError = false;
      this.isDragOver = false;

      this.messageService.add({
        severity: 'success',
        detail: `File "${event.fileName}" uploaded successfully from URL`,
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Error processing file from URL',
      });
    }
  }

  onLinkModalClosed(): void {
    this.showLinkModal = false;
    this.selectedFile = null;
    this.currentDocumentIndex = -1;
  }

  // Dropbox Methods
  openDropbox(documentIndex: number = -1): void {
    if (
      documentIndex < 0 ||
      documentIndex >= this.documentDetailsArray().length
    ) {
      this.messageService.add({
        severity: 'error',
        detail: `Invalid document slot index: ${documentIndex}`,
      });
      return;
    }

    this.currentDocumentIndex = documentIndex;
    if (!this.dropboxEnabled) return;
    this.showDropboxModal = true;
  }

  async onDropboxFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }): Promise<void> {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    if (
      this.currentDocumentIndex === -1 ||
      this.currentDocumentIndex === undefined ||
      this.currentDocumentIndex === null
    ) {
      this.messageService.add({
        severity: 'error',
        detail: 'No document slot selected for upload',
      });
      this.resetDropboxState();
      return;
    }

    if (this.currentDocumentIndex >= this.documentDetailsArray().length) {
      this.messageService.add({
        severity: 'error',
        detail: 'Invalid document slot selected',
      });
      this.resetDropboxState();
      return;
    }

    if (event.file.size > maxFileSize) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} exceeds 15MB limit`,
      });
      this.resetDropboxState();
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      this.resetDropboxState();
      return;
    }

    const isAlreadySelected = this.documentDetailsArray().controls.some(
      (control, index) => {
        if (index === this.currentDocumentIndex) {
          return false;
        }

        const existingFileName = control.get('fileName')?.value;
        const existingFile = control.get('file')?.value;

        return existingFileName === event.fileName && existingFile;
      },
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected in another document slot`,
      });
      this.resetDropboxState();
      return;
    }

    try {
      const base64Data = event.base64;
      const currentDocControl = this.documentDetailsArray().at(
        this.currentDocumentIndex,
      );

      if (!currentDocControl) {
        this.messageService.add({
          severity: 'error',
          detail: 'Could not access document slot',
        });
        this.resetDropboxState();
        return;
      }

      currentDocControl.get('file')?.setValue(base64Data);
      currentDocControl
        .get('fileUniqueId')
        ?.setValue(this.generateFileUniqueId());
      currentDocControl.get('fileName')?.setValue(event.fileName);

      this.fileSelectedMap[this.currentDocumentIndex] = true;
      if (event.file) {
        this.uploadedFileObjects[this.currentDocumentIndex] = event.file;
      }

      this.messageService.add({
        severity: 'success',
        detail: `File "${event.fileName}" uploaded successfully from Dropbox`,
      });

      const dropboxDocIdx = this.currentDocumentIndex;
      this.resetDropboxState();
      setTimeout(() => {
        this.previewNewlyUploadedEstamp(dropboxDocIdx);
        this.cdr.detectChanges();
      }, 400);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Error processing file from Dropbox',
      });
      this.resetDropboxState();
    }
  }

  private resetDropboxState(): void {
    this.showDropboxModal = false;
    this.showFileModal = false;
    this.selectedFile = null;
    this.selectedFileBase64 = '';
    this.currentDocumentIndex = -1;
    this.fileSizeError = false;
    this.isDragOver = false;
  }

  onDropboxModalClosed(): void {
    this.showDropboxModal = false;
    this.selectedFile = null;
  }

  // OneDrive Methods
  openOneDrive(documentIndex: number = -1): void {
    if (
      documentIndex < 0 ||
      documentIndex >= this.documentDetailsArray().length
    ) {
      this.messageService.add({
        severity: 'error',
        detail: `Invalid document slot index: ${documentIndex}`,
      });
      return;
    }

    this.currentDocumentIndex = documentIndex;
    this.showOneDriveModal = true;
  }

  async onOneDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }): Promise<void> {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit

    if (
      this.currentDocumentIndex === -1 ||
      this.currentDocumentIndex === undefined ||
      this.currentDocumentIndex === null
    ) {
      this.messageService.add({
        severity: 'error',
        detail: 'No document slot selected for upload',
      });
      this.resetOneDriveState();
      return;
    }

    if (this.currentDocumentIndex >= this.documentDetailsArray().length) {
      this.messageService.add({
        severity: 'error',
        detail: 'Invalid document slot selected',
      });
      this.resetOneDriveState();
      return;
    }

    if (event.file.size > maxFileSize) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} exceeds 15MB limit`,
      });
      this.resetOneDriveState();
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      this.resetOneDriveState();
      return;
    }

    const isAlreadySelected = this.documentDetailsArray().controls.some(
      (control, index) => {
        if (index === this.currentDocumentIndex) {
          return false;
        }

        const existingFileName = control.get('fileName')?.value;
        const existingFile = control.get('file')?.value;

        return existingFileName === event.fileName && existingFile;
      },
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected in another document slot`,
      });
      this.resetOneDriveState();
      return;
    }

    try {
      const base64Data = event.base64;
      const currentDocControl = this.documentDetailsArray().at(
        this.currentDocumentIndex,
      );

      if (!currentDocControl) {
        this.messageService.add({
          severity: 'error',
          detail: 'Could not access document slot',
        });
        this.resetOneDriveState();
        return;
      }

      currentDocControl.get('file')?.setValue(base64Data);
      currentDocControl
        .get('fileUniqueId')
        ?.setValue(this.generateFileUniqueId());
      currentDocControl.get('fileName')?.setValue(event.fileName);

      this.fileSelectedMap[this.currentDocumentIndex] = true;

      this.messageService.add({
        severity: 'success',
        detail: `File "${event.fileName}" uploaded successfully from OneDrive`,
      });

      const oneDriveDocIdx = this.currentDocumentIndex;
      this.resetOneDriveState();
      setTimeout(() => {
        this.previewNewlyUploadedEstamp(oneDriveDocIdx);
        this.cdr.detectChanges();
      }, 400);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Error processing file from OneDrive',
      });
      this.resetOneDriveState();
    }
  }

  private resetOneDriveState(): void {
    this.showOneDriveModal = false;
    this.showFileModal = false;
    this.selectedFile = null;
    this.selectedFileBase64 = '';
    this.currentDocumentIndex = -1;
    this.fileSizeError = false;
    this.isDragOver = false;
  }

  onOneDriveModalClosed(): void {
    this.showOneDriveModal = false;
    this.selectedFile = null;
  }
  private cascadeDefaultDataAfterUnchecking(uncheckedIndex: number): void {
    if (!this.estamp_default_fields || !this.estamp_default_fields[0]) {
      return;
    }

    const eStamp = this.estamp_default_fields[0];
    const stateWiseStampDuty =
      eStamp.estamp_default_fields.state_wise_stamp_duty;
    const formArray = this.documentDetailsArray();

    // Clear the unchecked form first
    this.clearFormAtIndex(uncheckedIndex);

    // Find all checked indices after the unchecked index
    const checkedIndicesAfter = [];
    for (let i = uncheckedIndex + 1; i < formArray.length; i++) {
      if (formArray.at(i).get('documentToBeEstamp')?.value) {
        checkedIndicesAfter.push(i);
      }
    }

    // Apply shifted default data to checked forms
    checkedIndicesAfter.forEach((checkedIndex, position) => {
      // Find the default data index by counting checked boxes before this form
      let defaultDataIndex = 0;
      for (let j = 0; j < checkedIndex; j++) {
        if (formArray.at(j).get('documentToBeEstamp')?.value) {
          defaultDataIndex++;
        }
      }

      // Apply the shifted default data
      if (defaultDataIndex < stateWiseStampDuty.length) {
        this.applyDefaultDataToIndex(checkedIndex, defaultDataIndex, eStamp);
        this.updateRelatedArraysForCascading(checkedIndex, defaultDataIndex);
      }
    });
  }

  private restoreDefaultDataAfterChecking(checkedIndex: number): void {
    if (!this.estamp_default_fields || !this.estamp_default_fields[0]) {
      return;
    }

    const eStamp = this.estamp_default_fields[0];
    const stateWiseStampDuty =
      eStamp.estamp_default_fields.state_wise_stamp_duty;
    const formArray = this.documentDetailsArray();

    // Get all currently checked indices (including the one just checked)
    const allCheckedIndices = [];
    for (let i = 0; i < formArray.length; i++) {
      if (formArray.at(i).get('documentToBeEstamp')?.value) {
        allCheckedIndices.push(i);
      }
    }

    // Re-apply default data to all checked forms based on their sequential order
    allCheckedIndices.forEach((formIndex, sequentialIndex) => {
      if (sequentialIndex < stateWiseStampDuty.length) {
        this.applyDefaultDataToIndex(formIndex, sequentialIndex, eStamp);
        this.updateRelatedArraysForRestoring(formIndex, sequentialIndex);
      }
    });
  }

  private applyDefaultDataToIndex(
    formIndex: number,
    defaultDataIndex: number,
    eStamp: any,
  ): void {
    const stateWiseStampDuty =
      eStamp.estamp_default_fields.state_wise_stamp_duty;
    const defaultData = stateWiseStampDuty[defaultDataIndex];
    const formControl = this.documentDetailsArray().at(formIndex);

    if (!defaultData || !formControl) {
      return;
    }

    // Apply default values
    formControl.patchValue({
      firstPartyName: eStamp.estamp_default_fields.first_party_name,
      secondPartyName: eStamp.estamp_default_fields.second_party_name,
      stampDutyPaidBy: eStamp.estamp_default_fields.stamp_duty_paid_by,
      stampDutyValue: defaultData.stamp_duty_amounts[0],
      purposeOfStampDuty: defaultData.description,
      considerationPrice: defaultData.consideration_amount,
      articleNumber: defaultData.article_id,
      selectedState: this.defaultState[defaultDataIndex] || this.stateSelected,
      selectBranch: this.selectedBranch,
      execution_date: this.today,
      documentToBeEstamp: true,
    });

    // Set the consideration price and stamp amount in words
    this.considerationPriceInWords[formIndex] =
      defaultData.consideration_amount;
    this.stampAmountInWords[formIndex] = defaultData.stamp_duty_amounts[0];

    // Update denomination data
    if (!this.denominationData[formIndex]) {
      this.denominationData[formIndex] = [];
    }
    this.denominationData[formIndex] = [
      { amount: defaultData.stamp_duty_amounts[0] },
    ];

    // Trigger article number change to populate dependent fields
    setTimeout(() => {
      this.setStampValueAndConsiderationPrice(
        defaultData.article_id,
        formIndex,
      );
    }, 100);
  }

  private updateRelatedArraysForCascading(
    toIndex: number,
    fromDefaultIndex: number,
  ): void {
    // Update articles array
    if (this.articles[0]) {
      this.articles[toIndex] = [...this.articles[0]];
    }

    // Reset validation arrays
    this.isConsiderationPriceValid[toIndex] = true;
    this.isStampValueValid[toIndex] = true;

    // Update default state
    if (this.defaultState[fromDefaultIndex]) {
      this.defaultState[toIndex] = this.defaultState[fromDefaultIndex];
    }

    // Update readonly flags
    this.readOnlyDefault[toIndex] = !this.estamp_field_editable;
  }

  private updateRelatedArraysForRestoring(
    toIndex: number,
    fromDefaultIndex: number,
  ): void {
    // Initialize arrays if they don't exist
    if (!this.articles[toIndex]) {
      this.articles[toIndex] = this.articles[0] ? [...this.articles[0]] : [];
    }

    if (!this.denominationData[toIndex]) {
      this.denominationData[toIndex] = [];
    }

    // Initialize validation arrays
    this.isConsiderationPriceValid[toIndex] = true;
    this.isStampValueValid[toIndex] = true;

    // Update default state
    if (this.defaultState[fromDefaultIndex]) {
      this.defaultState[toIndex] = this.defaultState[fromDefaultIndex];
    }

    // Update readonly flags
    this.readOnlyDefault[toIndex] = !this.estamp_field_editable;
  }

  private clearFormAtIndex(index: number): void {
    const formControl = this.documentDetailsArray().at(index);
    if (formControl) {
      // For first index (0), preserve file data
      if (index === 0) {
        formControl.patchValue({
          firstPartyName: '',
          secondPartyName: '',
          stampDutyPaidBy: '',
          stampDutyValue: null,
          purposeOfStampDuty: '',
          considerationPrice: 0,
          articleNumber: '',
          documentToBeEstamp: false,
          // Don't clear file, fileName, fileUniqueId for first index
        });

        // Don't clear fileSelectedMap for first index to keep form valid
      } else {
        formControl.patchValue({
          firstPartyName: '',
          secondPartyName: '',
          stampDutyPaidBy: '',
          stampDutyValue: null,
          purposeOfStampDuty: '',
          considerationPrice: '',
          articleNumber: '',
          documentToBeEstamp: false,
          file: null,
          fileName: null,
          fileUniqueId: null,
        });

        this.fileSelectedMap[index] = false;
      }

      // Clear related arrays for all indices
      this.considerationPriceInWords[index] = 0;
      this.stampAmountInWords[index] = null;
      this.denominationData[index] = [];
      this.selectedArticleAmount[index] = null;
      this.minStampValue[index] = null;
      this.isConsiderationPriceValid[index] = true;
      this.isStampValueValid[index] = true;
    }
  }
  areStampedDocumentsValid(): boolean {
    if (this.service === 'MULTIPLE-STAMP') {
      // For MULTIPLE-STAMP: validate reference number and rows where documentToBeEstamp = true
      const referenceNumberControl = this.estampDetails.get('referenceNumber');
      if (!referenceNumberControl || referenceNumberControl.invalid) {
        return false;
      }
      return this.documentDetailsArray().controls.every((control) => {
        const shouldBeStamped = control.get('documentToBeEstamp')?.value;
        return !shouldBeStamped || control.valid;
      });
    } else {
      // For single stamp service, use existing validation
      return this.estampDetails.valid;
    }
  }

  /*------------------------------- Draft functionality  --------------------------------------------*/

  checkAndPopulateDraft() {
    const draftData = this.storageService.getDraftData();
    if (
      this.currentOrderId !== null &&
      draftData &&
      draftData.order.id === this.currentOrderId
    ) {
      this.populateFormWithDraft(draftData);
    }
  }

  populateFormWithDraft(data: any) {
    this.isDraftLoading = true;

    if (data.order && data.order.referance_id) {
      this.estampDetails.controls['referenceNumber'].setValue(
        data.order.referance_id,
      );
      this.enableRefIdField = true;
    }

    while (this.documentDetailsArray().length !== 0) {
      this.documentDetailsArray().removeAt(0);
    }

    if (data.estamp && data.estamp.length > 0) {
      data.estamp.forEach((eStamp: any, index: number) => {
        this.documentDetailsArray().push(this.initDetails());
        this.isConsiderationPriceValid[index] = true;
        this.considerationPriceInWords[index] = eStamp.consideration_amount;
        this.stampAmountInWords[index] = eStamp.stamp_duty_amount;

        const formGroup = this.documentDetailsArray().at(index);
        const isDocumentOnly =
          eStamp.note === 'order_document_without_estamp' || !eStamp.estamp_id;

        if (isDocumentOnly) {
          formGroup
            .get('documentToBeEstamp')
            ?.setValue(false, { emitEvent: false });
          this.onDocumentToBeEstamp(index);

          if (eStamp.document && eStamp.document.file) {
            formGroup.patchValue(
              {
                file: eStamp.document.file,
                fileName: eStamp.document.file_name,
                fileUniqueId: this.generateFileUniqueId(),
              },
              { emitEvent: false },
            );
            this.fileSelectedMap[index] = true;
          }

          return;
        }

        formGroup.patchValue(
          { estamp_id: eStamp.estamp_id },
          { emitEvent: false },
        );

        const matchingState = this.stateData.find(
          (s) => s.id === eStamp.state.id,
        );
        if (matchingState) {
          formGroup
            .get('selectedState')
            ?.setValue(matchingState, { emitEvent: false });
          this.getBranchDetails(matchingState.id).subscribe(
            (branchRes: any) => {
              if (branchRes && branchRes['content']) {
                this.branchData[index] = branchRes['content'];
                const branchToSelect = this.branchData[index].find(
                  (b) => b.id === data.order.branch,
                );
                if (branchToSelect) {
                  formGroup.get('selectBranch')?.setValue(branchToSelect);
                }
              }
            },
          );

          this.getArticles(matchingState.state_code).subscribe((res: any) => {
            const articleList = res && res['content'] ? res['content'] : res;
            if (Array.isArray(articleList)) {
              this.articles[index] = articleList;
              formGroup
                .get('articleNumber')
                ?.setValue(eStamp.article_id, { emitEvent: false });
              this.onArticleNumberChange({ value: eStamp.article_id }, index);
              setTimeout(() => {
                const currentGroup = this.documentDetailsArray().at(index);
                currentGroup.patchValue(
                  {
                    considerationPrice: eStamp.consideration_amount,
                    stampDutyValue: eStamp.stamp_duty_amount,
                  },
                  { emitEvent: false },
                );
                this.considerationPriceInWords[index] =
                  eStamp.consideration_amount;
                this.stampAmountInWords[index] = eStamp.stamp_duty_amount;
                currentGroup
                  .get('stampDutyValue')
                  ?.updateValueAndValidity({ emitEvent: false });
              }, 600);
            }
          });
          this.getEstampIndividualFields(matchingState.state_code, index);
        }

        let paidByCode =
          eStamp.stamp_duty_paid_by === eStamp.first_party_name
            ? 'first_party_name'
            : eStamp.stamp_duty_paid_by === eStamp.second_party_name
              ? 'second_party_name'
              : eStamp.stamp_duty_paid_by;

        formGroup.patchValue(
          {
            firstPartyName: eStamp.first_party_name,
            secondPartyName: eStamp.second_party_name,
            stampDutyPaidBy: paidByCode,
            purposeOfStampDuty: eStamp.description,
            process_type: eStamp.process_type,
          },
          { emitEvent: false },
        );
        this.fileSelectedMap[index] = true;

        if (eStamp.document && eStamp.document.file) {
          formGroup.patchValue({
            file: eStamp.document.file,
            fileName: eStamp.document.file_name,
            fileUniqueId: this.generateFileUniqueId(),
          });
          this.fileSelectedMap[index] = true;
        }
      });

      this.validateSecondPartyNameConsistency();
      this.validateConsiderationPriceConsistency();
      this.validateSyncFieldsConsistency();

      setTimeout(() => {
        this.isDraftLoading = false;
      }, 2500);
    }
  }

  updateRazorypayFieldValidation() {
    const isPaymentSectionVisible =
      this.validationForRazorypay &&
      this.pathId &&
      this.showPayment &&
      this.process_type === 'ON_THE_FLY';

    if (isPaymentSectionVisible) {
      this.estampDetails.controls['payeeName'].setValidators([
        Validators.required,
      ]);
      this.estampDetails.controls['payeeEmail'].setValidators([
        Validators.required,
        Validators.email,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]);
      this.estampDetails.controls['payeeMobileNumber'].setValidators([
        Validators.required,
        Validators.pattern(this.phonePattern),
        Validators.maxLength(10),
        Validators.minLength(10),
      ]);
    } else {
      this.estampDetails.controls['payeeName'].clearValidators();
      this.estampDetails.controls['payeeEmail'].clearValidators();
      this.estampDetails.controls['payeeMobileNumber'].clearValidators();
    }
    this.estampDetails.controls['payeeName'].updateValueAndValidity({
      emitEvent: false,
    });
    this.estampDetails.controls['payeeEmail'].updateValueAndValidity({
      emitEvent: false,
    });
    this.estampDetails.controls['payeeMobileNumber'].updateValueAndValidity({
      emitEvent: false,
    });
  }

  getAvailableProviders(): string[] {
    return this.storageService.getPaymentProviders();
  }

  hasProvider(provider: string): boolean {
    return this.getAvailableProviders().includes(provider);
  }
}

/*------------------------------- eStamp End --------------------------------------------*/
